<template>
  <v-container fluid class="px-4">
		<div v-m2-span>
			<div class="my-4 mx-2">
				<div class="d-flex align-center">
					<div class="flex-grow-1 mr-2" style="border-bottom: 1px solid #ccc;"></div>
					<span class="mx-2 font-weight-bold body-1">Tabla Subcontratos</span>
					<div class="flex-grow-1 ml-2" style="border-bottom: 1px solid #ccc;"></div>
				</div>
				<div class="d-flex justify-center align-center" style="gap: 5px;" v-if="showTopButtons">
					<div v-if="!isSubcontractor">
						<v-tooltip bottom>
							<template v-slot:activator="{ on, attrs }">
								<v-btn
									depressed
									color="grey"
									small
									icon
									v-show="showShowMainTable"
									v-bind="attrs"
									v-on="on"
									@click.stop="$store.commit('costbreakdown/setCostBreakdownMainTableModal', true)"
								>
									<v-icon>mdi-eye</v-icon>
								</v-btn>
							</template>
							<span>Visualización Rápida Tabla General</span>
						</v-tooltip>
					</div>
					<div v-if="!isSubcontractor">
						<v-tooltip bottom>
							<template v-slot:activator="{ on, attrs }">
								<v-btn
									depressed
									color="grey"
									small
									icon
									v-show="showShowMainTable"
									v-bind="attrs"
									v-on="on"
									@click.stop="openCostBreakdownSummary({ showPaymentConfig: true })"
								>
									<v-icon>mdi-table-eye</v-icon>
								</v-btn>
							</template>
							<span>Visualización Rápida Tabla Programación Pagos</span>
						</v-tooltip>
					</div>
					<v-menu
						v-model="colorPickerVisible"
						:close-on-content-click="false"
						offset-y
					>
						<template v-slot:activator="{ on, attrs }">
							<v-btn
								icon
								depressed
								color="grey"
								small
								v-bind="attrs"
								v-on="on"
							>
								<v-icon>mdi-palette</v-icon>
							</v-btn>
						</template>
						<v-card>
							<div>
								<div class="pa-2">
									<p class="mb-0 caption font-weight-bold">Selecciona Un Color a Editar</p>
									<p class="mb-1" style="font-size: 10px">Selecciona el color de la tabla que quieres modificar</p>
									<div class="d-flex align-center">
										<v-tooltip bottom
													v-for="(colorVar, key) in colorVars"
													:key="key">
											<template v-slot:activator="{ on, attrs }">
												<v-btn
													depressed
													color="white"
													small
													icon
													v-bind="attrs"
													v-on="on"
													:style="{
														border: activeColorKey === colorVar.value ? '2px solid #000' : '2px solid #cecece',
														marginRight: '5px',
														boxShadow: activeColorKey === colorVar.value ? '0 0 5px rgba(0,0,0,0.3)' : 'none'
													}"
													@click="openColorPicker(colorVar.value)"
												>
													<v-icon :color="colors[colorVar.value]">mdi-circle</v-icon>
												</v-btn>
											</template>
											<span>{{colorVar.text}}</span>
										</v-tooltip>
									</div>
								</div>
								<v-color-picker
									v-model="currentColor"
									dot-size="25"
									hide-sliders
									mode="rgba"
									dense
									show-swatches
									swatches-max-height="100"
								/>
							</div>
							<v-card-actions>
								<v-spacer></v-spacer>
								<v-btn text @click="colorPickerVisible = false">Cerrar</v-btn>
							</v-card-actions>
						</v-card>
					</v-menu>
					<div>
						<v-tooltip bottom>
							<template v-slot:activator="{ on, attrs }">
								<v-btn
									depressed
									:color="showAnulatedSubcontracts ? 'green' : 'grey'"
									small
									icon
									v-bind="attrs"
									v-on="on"
									@click.stop="toggleShowAnulatedSubcontracts"
								>
									<v-icon>mdi-briefcase-search-outline</v-icon>
								</v-btn>
							</template>
							<span>También se mostrarán los subcontratos anulados</span>
						</v-tooltip>
					</div>
					<!-- <div>
						<UserChatSelectorMenu
							:users="subcontractorsForChat"
							:currentUserId="userInfo.id"
							:projectLineId="project?.project_line_info?.project_line_id"
							:projectLineNumber="project?.project_line_info?.project_line?.number"
							:projectName="project?.name"
							:excludeCurrentUser="true"
							:excludeProjectLine="true"
							:color="colors.fontColor"
							tooltipText="Chatear con Subcontratistas Disponibles"
							:iconButton="true"
						/>
					</div> -->
				</div>
			</div>
			<div v-if="main_contract && main_contract.last_status?.status !== contractStatuses.FIRMADO_AMBAS_PARTES" class="my-4">
				<v-alert
					type="warning"
					outlined
					dense
					class="mb-3 py-2 px-3"
					style="text-align: center;"
				>
					<p class="mb-1 subtitle-2 font-weight-bold">El contrato principal no ha sido firmado</p>
					<p class="mb-0 caption">Una vez que el contrato principal esté firmado podrás configurar los estados de pago de los subcontratos.</p>
				</v-alert>
				<v-divider class="my-3"></v-divider>
				<div>
					<p class="mb-4 text-center caption font-weight-bold">Mientras tanto puedes conversar con los subcontratistas de la empresa y preparar las opciones para cada proyecto.</p>
					<SubcontractorPreselectionChat
						:project="project"
						:users="subcontractorsForChat" />
				</div>
			</div>
			<div v-else-if="orderedBySubcontract.length === 0" class="my-4">
				<p class="mb-0 text-center subtitle-1 font-weight-bold">No se han asignado proyectos para subcontrato</p>
				<p class="mb-0 text-center caption">Si necesitas agregar un subproyecto lo puedes hacer en la sección Tabla Resumen / Programación Pagos.</p>
				<div class="d-flex justify-center mt-4">
					<v-btn
						depressed
						color="#FF120B"
						small
						dark
						@click="$router.replace( '#summary' )"
					>
						<!-- <v-icon small>mdi-check</v-icon> -->
						<p class="mb-0 ml-2 caption">Ir a sección Tabla Resumen / Programación Pagos</p>
					</v-btn>
				</div>
			</div>
			<div v-else>
				<div ref="line_parent" class="parent-node-line text-center" :style="{ backgroundColor: subcontractConfigTableColor, color: calcFontColor(subcontractConfigTableColor) }">
					<p class="mb-0" style="font-size: 10px;">Contrato</p>
					<p class="mb-0 caption font-weight-bold">{{contractCode}}</p>
				</div>
				<template v-for="(subcontract,index) in orderedBySubcontract">
					<div :class="!subcontract.subcontract && $vuetify.breakpoint.width > 1530 ? 'd-flex' : ''" :key="'subcontract_table_'+(subcontract.subcontract?.id || 'no_subcontract')">
						<div class="d-flex flex-column align-center">
							<div class="d-flex flex-column align-self-start justify-start flex-1 flex-grow-1" v-m2-span :style="{ color: colors.fontColor }">
								<div class="d-flex align-center flex-1 px-2 py-1" style="gap: 5px;color: orange;margin-left: 20px;" v-if="showSubcontractInfo(subcontract)">
									<v-icon color="orange">mdi-alert-box-outline</v-icon>
									<div>
										<p class="mb-0 font-weight-bold caption">No puedes editar este subcontrato hasta que todos los estados de pago estén configurados y el neto del subcontrato sea mayor a 0.</p>
										<p class="mb-0 caption">En cada fila, la columna Totales debe ser 100% y el monto del subcontrato debe ser diferente de 0.</p>
									</div>
								</div>
							</div>

							<!-- {{ nextSubpayment }} -->
							<!-- <StartPaymentSelection
								:payment="nextSubpayment"
								:clp_amount="calculatedValues.clp"
								:uf_amount="calculatedValues.uf"
								v-if="subcontractSigned || subcontractSuspended"/> -->
							<div class="d-flex align-self-end justify-end flex-shrink-0" style="gap: 5px;" v-if="checkIfSubcontractContract(subcontract)">
								<SubcontractorPreselectionChat
									:showButton="true"
									:project="project"
									:users="subcontractorsForChat"
									:showAsMenu="true"/>

								<v-tooltip bottom>
									<template v-slot:activator="{ on, attrs }">
										<v-btn
											outlined
											dark
											small
											color="#959595"
											@click="toSubcontractorChat(subcontract)"
											v-bind="attrs"
											v-on="on"
										>
											<v-icon dark small class="mr-2">mdi-comment-account-outline</v-icon>
											<p class="mb-0 caption">Ir al Chat</p>
										</v-btn>
									</template>
									<span>Chatear con Subcontratista</span>
								</v-tooltip>
								<SubcontractUfTaxSelector
									:subcontract="subcontract"
									@info-updated="updateSubcontractTaxUfInfo"
									/>
							</div>
						</div>
						<div :ref="'line_child' + index" class="child-node-line" :style="!subcontract.subcontract && $vuetify.breakpoint.width > 1530 ? { 'max-width': '550px' } : {}">
							<v-simple-table style="zoom: 90%" class="custom-table-cost caption mt-2 mb-6" :style="{'width': !checkIfSubcontractContract(subcontract) ? '900px' : 'auto'}">
								<template v-slot:default>
									<thead>
										<tr class="header-rows-custom" :style="{ backgroundColor: subcontractConfigTableColor, color: calcFontColor(subcontractConfigTableColor) }">
											<td class="pa-0" style="vertical-align: middle;min-width: 240px;" rowspan="2" :width="colWidths[0]" :style="{ backgroundColor: subcontractConfigTableColor, color: calcFontColor(subcontractConfigTableColor) }">
												<ContractorInfo
													:ref="'line_child_start' + index"
													:subcontract="subcontract"
													:project="project"
													:main_contract="project.contract"
													:costsTable="costsTable"
													:annulated="subcontract.type === 'anulated'"
													:showToContractButton="showTopButtons"
													:colors="{ background: subcontractConfigTableColor, fontColor: calcFontColor(subcontractConfigTableColor) }"
												/>
											</td>
											<td style="vertical-align: middle;width: 130px;min-width: 130px;" class="text-right" rowspan="2" :style="{'opacity': subcontract.type === 'anulated' ? 0.5 : 1}"
												v-if="!isSubcontractor">
												<div class="d-flex flex-column align-end justify-center">
													<p class="mb-0 font-weight-bold caption">Contrato</p>
													<p class="mb-0 caption">Imp. incluido</p>
												</div>
											</td>
											<td style="vertical-align: middle;width: 120px;min-width: 120px;" colspan="3" class="text-right" :style="{'opacity': subcontract.type === 'anulated' ? 0.5 : 1}"
												v-if="checkIfSubcontractContract(subcontract)">
												<div class="d-flex flex-column align-center justify-center">
													<p class="mb-0 font-weight-bold caption">Subcontrato</p>
												</div>
											</td>
											<template v-if="checkIfSubcontractContract(subcontract)">
												<td v-for="(costsPayment, indexPayment) in costsPayments"
													style="vertical-align: middle;min-width: 200px;max-width: 200px;width: 200px;"
													:style="{'opacity': subcontract.type === 'anulated' ? 0.5 : 1}"
													:key="'projectPlannedSubcontractPaymentsHeaders_'+costsPayment.id"
													colspan="2">
													<p class="text-center mb-0" style="font-size: 10px;opacity: 0.6">Estado Pago {{indexPayment + 1}}</p>
													<p class="text-center mb-0 caption font-weight-bold" style="opacity: 0.6">{{costsPayment.stage?.name}}{{ costsPayment.stage?.description ? ': '+costsPayment.stage?.description:''}}</p>
												</td>
											</template>
											<td style="vertical-align: middle;width: 120px;min-width: 120px;" class="text-right" rowspan="3" :style="{'opacity': subcontract.type === 'anulated' ? 0.5 : 1}"
												v-if="checkIfSubcontractContract(subcontract)">
												<div class="d-flex align-center justify-end">
													<p class="mb-0 font-weight-bold">Totales</p>
												</div>
											</td>
										</tr>
										<tr class="header-rows-custom"
											:style="{ backgroundColor: subcontractConfigTableColor, color: calcFontColor(subcontractConfigTableColor) }"
											v-if="checkIfSubcontractContract(subcontract)">
											<td style="vertical-align: middle;width: 120px;min-width: 120px;" class="text-right" :style="{'opacity': subcontract.type === 'anulated' ? 0.5 : 1}">
												<div class="d-flex flex-column align-end justify-center">
													<p class="mb-0 font-weight-bold caption">Neto</p>
												</div>
											</td>
											<td style="vertical-align: middle;width: 120px;min-width: 120px;" class="text-right" :style="{'opacity': subcontract.type === 'anulated' ? 0.5 : 1}">
												<div class="d-flex flex-column align-end justify-center">
													<p class="mb-0 font-weight-bold caption">Impuesto</p>
												</div>
											</td>
											<td style="vertical-align: middle;width: 120px;min-width: 120px;" class="text-right" :style="{'opacity': subcontract.type === 'anulated' ? 0.5 : 1}">
												<div class="d-flex flex-column align-end justify-center">
													<p class="mb-0 font-weight-bold caption">Total A Pagar</p>
												</div>
											</td>
											<template v-for="(costsPayment) in costsPayments">
												<td
													:key="'projectPlannedStageHeadersA_'+costsPayment.id"
													style="width: 40px;min-width: 40px;"
													:style="{'opacity': subcontract.type === 'anulated' ? 0.5 : 1}"
													class="px-1">
													<p class="text-center mb-0" style="font-size: 10px;">%</p>
												</td>
												<td
													:key="'projectPlannedStageHeadersB_'+costsPayment.id"
													style="width:90px;min-width: 90px;"
													:style="{'opacity': subcontract.type === 'anulated' ? 0.5 : 1}"
													class="px-1">
													<p class="text-center mb-0" style="font-size: 10px;">Monto Cuota</p>
												</td>
											</template>
										</tr>
										<tr class="header-rows-custom" :style="{ backgroundColor: subcontractConfigTableColorSubheader, color: calcFontColor(subcontractConfigTableColorSubheader) }">
											<template v-if="checkIfSubcontractContract(subcontract)">
												<td colspan="5">
													<p class="mb-0 text-right caption font-weight-bold">Títulos de EP, específicos para subcontrato</p>
												</td>
												<td v-for="(costsPayment, indexPayment) in costsPayments"
													style="vertical-align: middle;min-width: 200px;max-width: 200px;width: 200px;"
													:style="{'opacity': subcontract.type === 'anulated' ? 0.5 : 1}"
													:key="'projectPlannedSubcontractPaymentsHeaders_'+costsPayment.id"
													colspan="2">
													<p class="mb-0 caption font-weight-bold text-center" v-if="hasPaymentInStage(subcontract, costsPayment)">Etapa {{ getCorrelativeStageIndex(subcontract, indexPayment) }}</p>
													<p class="mb-0 caption font-weight-bold text-center" v-else>--</p>
													<v-text-field
														v-model="costsPayment.subcontract_stage_title"
														label="Nombre Estado de Pago"
														outlined
														required
														dense
														hide-details
														:color="calcFontColor(subcontractConfigTableColorSubheader)"
														:key="indexPayment"
														@input="(value) => $emit('update:SubcontractStageTitle', {title: value, payment_id: costsPayment.id})"
														class="custom-height-search custom-height-calendar w-100 py-1 px-0 mt-2 custom-text-field"
														:style="{
															'--c': calcFontColor(subcontractConfigTableColorSubheader)
														}"
													></v-text-field>
												</td>
											</template>
										</tr>
									</thead>
									<CostTableBodyRow
										v-for="costTableInfo in subcontract.items.mainProjects"
										:ref="'line_element_container' + index"
										:key="'subcontract_body_mp_'+costTableInfo.item_id"
										:item="costTableInfo"
										:item-type="'cost_table'"
										:subcontract="subcontract"
										:costs-payments="costsPayments"
										:costs-table="costsTable"
										:summary-subcontract-info="summarySubcontractInfo"
										:parent-methods="{
											getTaxValueFromSubcontract, getTaxFromValue, getValueWithTax, getPaymentValue, getItemPaymentValue,
											getPaymentSubtotalWithAdjustment, getCalculatedSubpayments, hasAnyPaymentConfiguredForItem,
											getAllPaymentPercentValues, checkIfSubcontractContract, getBlockedItemsClass, subcontractSigned,
											getCorrelativeStageIndex, startConfigSubpayments, removeItemFromSubcontract, getSubcontractsInfoForMainProject,
											sanitizeUF, sanitizeIntegerInput, sanitizeAdditionalUF, sanitizeIntegerAdditionalInput, validateCLP,
											onKeyPress, calcFontColor, hasAnulatedSubcontract
										}"
										:index="index"
										:subcontract-index="index"
										:project="project"
										:col-widths="colWidths"
										:uf-value="ufValue"
										:currency="currency"
										:is-subcontractor="isSubcontractor"
										:subcontract-config-table-color="subcontractConfigTableColor"
										:add-additional-amount-id="addAdditionalAmountId"
										:required-rule="requiredRule"
										@update:contractor="handleUpdateContractor"
										@update:subcontract="handleUpdateSubcontractor"
										@update-amount="handleUpdateSubpaymentAmount"
										@update-title="handleUpdateSubpaymentTitle"
										@remove-subpayment="handleRemoveSubpayment"
									/>
									<CostTableBodyRow
										v-for="stage in subcontract.items.stages"
										:ref="'line_element_container' + index"
										:key="'subcontract_body_st_'+stage.item_id"
										:item="stage"
										:item-type="'stage'"
										:subcontract="subcontract"
										:index="index"
										:subcontract-index="index"
										:costs-payments="costsPayments"
										:costs-table="costsTable"
										:summary-subcontract-info="summarySubcontractInfo"
										:project="project"
										:col-widths="colWidths"
										:uf-value="ufValue"
										:currency="currency"
										:is-subcontractor="isSubcontractor"
										:subcontract-config-table-color="subcontractConfigTableColor"
										:add-additional-amount-id="addAdditionalAmountId"
										:required-rule="requiredRule"
										:parent-methods="{
											getTaxValueFromSubcontract, getTaxFromValue, getValueWithTax, getPaymentValue, getItemPaymentValue,
											getPaymentSubtotalWithAdjustment, getCalculatedSubpayments, hasAnyPaymentConfiguredForItem,
											getAllPaymentPercentValues, checkIfSubcontractContract, getBlockedItemsClass, subcontractSigned,
											getCorrelativeStageIndex, startConfigSubpayments, removeItemFromSubcontract, getSubcontractsInfoForMainProject,
											sanitizeUF, sanitizeIntegerInput, sanitizeAdditionalUF, sanitizeIntegerAdditionalInput, validateCLP,
											onKeyPress, calcFontColor, hasAnulatedSubcontract
										}"
										@update:contractor="handleUpdateContractor"
										@update:subcontract="handleUpdateSubcontractor"
										@update-amount="handleUpdateSubpaymentAmount"
										@update-title="handleUpdateSubpaymentTitle"
										@remove-subpayment="handleRemoveSubpayment"
									/>
									<CostTableBodyRow
										v-if="subcontract.items.reception"
										:ref="'line_element_container' + index"
										:key="'subcontract_body_reception'"
										:item="subcontract.items.reception"
										:item-type="'reception'"
										:subcontract="subcontract"
										:index="index"
										:subcontract-index="index"
										:costs-payments="costsPayments"
										:costs-table="costsTable"
										:summary-subcontract-info="summarySubcontractInfo"
										:project="project"
										:col-widths="colWidths"
										:uf-value="ufValue"
										:currency="currency"
										:is-subcontractor="isSubcontractor"
										:subcontract-config-table-color="subcontractConfigTableColor"
										:add-additional-amount-id="addAdditionalAmountId"
										:required-rule="requiredRule"
										:parent-methods="{
											getTaxValueFromSubcontract, getTaxFromValue, getValueWithTax, getPaymentValue, getItemPaymentValue,
											getPaymentSubtotalWithAdjustment, getCalculatedSubpayments, hasAnyPaymentConfiguredForItem,
											getAllPaymentPercentValues, checkIfSubcontractContract, getBlockedItemsClass, subcontractSigned,
											getCorrelativeStageIndex, startConfigSubpayments, removeItemFromSubcontract, getSubcontractsInfoForMainProject,
											sanitizeUF, sanitizeIntegerInput, sanitizeAdditionalUF, sanitizeIntegerAdditionalInput, validateCLP,
											onKeyPress, calcFontColor, hasAnulatedSubcontract
										}"
										@update:contractor="handleUpdateContractor"
										@update:subcontract="handleUpdateSubcontractor"
										@update-amount="handleUpdateSubpaymentAmount"
										@update-title="handleUpdateSubpaymentTitle"
										@remove-subpayment="handleRemoveSubpayment"
									/>
									<CostTableBodyRow
										v-for="specialty in subcontract.items.specialties"
										:ref="'line_element_container' + index"
										:key="'subcontract_body_st_'+specialty.item_id"
										:item="specialty"
										:item-type="'specialty'"
										:subcontract="subcontract"
										:index="index"
										:subcontract-index="index"
										:costs-payments="costsPayments"
										:costs-table="costsTable"
										:summary-subcontract-info="summarySubcontractInfo"
										:project="project"
										:col-widths="colWidths"
										:uf-value="ufValue"
										:currency="currency"
										:is-subcontractor="isSubcontractor"
										:subcontract-config-table-color="subcontractConfigTableColor"
										:add-additional-amount-id="addAdditionalAmountId"
										:required-rule="requiredRule"
										:parent-methods="{
											getTaxValueFromSubcontract, getTaxFromValue, getValueWithTax, getPaymentValue, getItemPaymentValue,
											getPaymentSubtotalWithAdjustment, getCalculatedSubpayments, hasAnyPaymentConfiguredForItem,
											getAllPaymentPercentValues, checkIfSubcontractContract, getBlockedItemsClass, subcontractSigned,
											getCorrelativeStageIndex, startConfigSubpayments, removeItemFromSubcontract, getSubcontractsInfoForMainProject,
											sanitizeUF, sanitizeIntegerInput, sanitizeAdditionalUF, sanitizeIntegerAdditionalInput, validateCLP,
											onKeyPress, calcFontColor, hasAnulatedSubcontract
										}"
										@update:contractor="handleUpdateContractor"
										@update:subcontract="handleUpdateSubcontractor"
										@update-amount="handleUpdateSubpaymentAmount"
										@update-title="handleUpdateSubpaymentTitle"
										@remove-subpayment="handleRemoveSubpayment"
									/>
									<tbody
										v-if="checkIfSubcontractContract(subcontract)"
										:key="'subcontract_totals_' + (subcontract.subcontract?.id || 'none')"
									>
										<tr class="header-rows-custom" :style="{ backgroundColor: subcontractConfigTableColor, color: calcFontColor(subcontractConfigTableColor) }">
											<td style="vertical-align: middle;min-width: 240px;padding-left: 30px!important;" :width="colWidths[0]" class="text-left pr-2">
												<div class="d-flex align-center justify-space-between my-1">
													<p class="mb-0 font-weight-bold">Totales Subcontrato</p>
												</div>
											</td>
											<td style="vertical-align: middle;" class="text-right" v-if="!isSubcontractor">
												<div>
													<p class="mb-0 caption font-weight-bold">{{ calculateSubcontractContractTotals(subcontract).uf | toThousandFilter(2) }} UF</p>
													<p class="mb-0 caption font-weight-bold">${{ calculateSubcontractContractTotals(subcontract).clp | toThousandFilter }} CLP</p>
												</div>
											</td>
											<td style="vertical-align: middle;" class="text-right">
												<div>
													<p class="mb-0 caption font-weight-bold">{{ calculateSubcontractTotals(subcontract).cost_uf | toThousandFilter(2) }} UF</p>
													<p class="mb-0 caption font-weight-bold">${{ calculateSubcontractTotals(subcontract).cost_clp | toThousandFilter }} CLP</p>
												</div>
											</td>
											<td style="vertical-align: middle;" class="text-right">
												<div>
													<p class="mb-0 caption font-weight-bold">{{ calculateSubcontractTotals(subcontract).tax_uf | toThousandFilter(2) }} UF</p>
													<p class="mb-0 caption font-weight-bold">${{ calculateSubcontractTotals(subcontract).tax_clp | toThousandFilter }} CLP</p>
													<p class="mb-0 text-right" style="font-size: 11px;">{{ calculateSubcontractTotals(subcontract)?.tax?.name }} {{ calculateSubcontractTotals(subcontract)?.tax?.value }}%</p>
												</div>
											</td>
											<td style="vertical-align: middle;" class="text-right">
												<div>
													<p class="mb-0 caption font-weight-bold">{{ calculateSubcontractTotals(subcontract).total_with_tax_uf | toThousandFilter(2) }} UF</p>
													<p class="mb-0 caption font-weight-bold">${{ calculateSubcontractTotals(subcontract).total_with_tax_clp | toThousandFilter }} CLP</p>
												</div>
											</td>
											<td
												v-for="(costsPayment) in costsPayments"
												:key="'subcontract_total_payment_' + costsPayment.id"
												class="px-1"
												colspan="2"
												style="vertical-align: top;"
											>
												<div>
													<p class="mb-0 caption font-weight-bold text-right">{{ getSubcontractPaymentTotals(subcontract, costsPayment).uf | toThousandFilter(2) }} UF</p>
													<p class="mb-0 caption font-weight-bold text-right">${{ getSubcontractPaymentTotals(subcontract, costsPayment).clp | toThousandFilter }} CLP</p>
												</div>
											</td>
											<td :style="{ backgroundColor: subcontractConfigTableColor, color: calcFontColor(subcontractConfigTableColor) }" class="text-left pr-2">
												<div class="text-right">
													<p class="mb-0 font-weight-bold">{{ getSubcontractConfiguredTotals(subcontract).uf | toThousandFilter(2) }} UF</p>
													<p class="mb-0 font-weight-bold">${{ getSubcontractConfiguredTotals(subcontract).clp | toThousandFilter }} CLP</p>
												</div>
											</td>
										</tr>
									</tbody>
									<SubcontractRequestsResolutionHandler :subcontract="subcontract" />
								</template>
							</v-simple-table>
						</div>
						<div style="width: 100%;" v-if="!subcontract.subcontract">
							<SubcontractorPreselectionChat
								:showButton="true"
								:project="project"
								:users="subcontractorsForChat" />
						</div>
					</div>
				</template>
			</div>
		</div>
	</v-container>
</template>

<script>
import { debounce } from 'lodash';
import _debounce from 'lodash/debounce'
import LeaderLine from 'leader-line-new'
import { contractStatuses } from '@/components/Helpers/Constants/contract.js'
import ContractorInfo from '@/components/Views/Projects/CostSummary/ContractorInfo';
// import SubcontractorContractValueDisplay from '@/components/Views/Projects/CostSummary/SubcontractorContractValueDisplay'
import SubcontractRequestsResolutionHandler from '@/components/Views/Projects/Parts/SubcontractRequestsResolutionHandler'
import SubcontractUfTaxSelector from '@/components/Views/Projects/CostSummary/SubcontractUfTaxSelector'
import CostTableBodyRow from '@/components/Views/Projects/CostSummary/CostTableBodyRow'
import SubcontractorPreselectionChat from '@/components/Views/Projects/Parts/SubcontractorPreselectionChat'
// import UserChatSelectorMenu from '@/components/Helpers/Components/UserChatSelectorMenu'
import {saveProjectCostDetail} from '@/helpers/api/costs'
import {createUserChatRoom} from '@/helpers/api/chats'
import { getParentItemTotalValueMultiWithTax, getParentItemTotalValueWithTax, getSinglePaymentTotalsWithTax, getAllPaymentsTotalsWithTax } from '@/helpers/tablecostHelpers.js'

export default {
	name: 'CostSubcontractPaymentsConfigTable',
	components: { ContractorInfo, SubcontractRequestsResolutionHandler, SubcontractUfTaxSelector, CostTableBodyRow, SubcontractorPreselectionChat },
	props: {
		project: {
			type: Object,
			required: true
		},
		ufValue: {
			type: Number,
			required: true
		},
		currency: {
			type: [String, Number],
			required: true
		},
		showShowMainTable: {
			type: Boolean,
			default: true
		},
		focusedTab: {
			type: Number,
			default: 0
		},
		costsTable: {
			type: Object,
			required: true
		},
		fromSubcontractor: {
			type: Boolean,
			default: false
		},
		saveSelf: {
			type: Boolean,
			default: false
		},
		showTopButtons: {
			type: Boolean,
			default: true
		}
	},
  data() {
    return {
			contractStatuses,
			getParentItemTotalValueMultiWithTax,
			getParentItemTotalValueWithTax,
			getSinglePaymentTotalsWithTax,
			getAllPaymentsTotalsWithTax,
			addAdditionalAmountId: null,
			colWidths: ['15%','11%','11%','11%','11%','11%','11%','11%'],
      colorVars: [
        {'value': 'subcontractConfigTableColor', 'text': 'Título / Cabecera Tabla Subcontratos'},
        {'value': 'subcontractConfigTableColorSubheader', 'text': 'Subcabecera Nombres estados de pago Subcontrato'},
        // {'value': 'footerSummaryTables', 'text': 'Footer Summary Tables'},
      ],
      colorPickerVisible: false,
      activeColorKey: 'subcontractConfigTableColor',
			requiredRule: [
				v => !!v || 'Campo requerido'
			],
			acceptRejectModal: false,
			acceptRejectModalData: null,
			costTableSubcontractinfo: null,
			stagesSubcontractinfo: [],
			specialtiesSubcontractinfo: [],
			receptionSubcontractinfo: null,
			receptionAnnulatedSubcontractinfo: [],
			costTableAnnulatedSubcontractinfo: [],
			line: null,
			lines: [],
			redrawingLines: false,
			showAnulatedSubcontracts: false,
			userHasChangeAnnulatedSubcontractShow: false,
			shouldRecalculateBaseValues: false,
			updatingFromParent: false,
			lastEmitKey: null
    };
  },
	computed: {
		userInfo() {
			return this.$store.state.user.userInfo || {}
		},
		ufValues(){
			return this.$store.state.general.posteriorDaysUf
		},
		taxOptions(){
			return this.$store.state.general.taxesOptions
		},
		isSubcontractor(){
			return this.$store.state.user.companyPermissions?.subcontractor === true
		},
		readOnlyMode() {
			return this.isSubcontractor
		},
		project_tables(){
			return this.costsTable.project_tables || []
		},
		main_contract(){
			console.log('this.project.contracts', this.project.contract)
			return this.project.contract
		},
		contractCode() {
			const contract = this.project.contract
			console.log('contract contractCode', contract)
			if(this.contract){
				let append = ''
				if(contract.addendum_to_contract_id){
					append = ` - ANX Nº ${contract.addendum_index}`
				}
				else if(contract.subcontract_to_contract_id){
					append = ` - SUB Nº ${contract.subcontract_index}`
				}
				return `${contract.serial?.serial} - LP${this.project?.project_line_info?.project_line?.number} - ${contract.info?.prefix?.prefix} ${this.contract?.info?.contract_prefix_index} ${append}`
			}
			return `${contract.serial?.serial} - LP${this.project?.project_line_info?.project_line?.number} - ${contract.info?.prefix?.prefix} ${contract.info?.contract_prefix_index}`
		},
		projectTypeSubtitle() {
			const parentName = this.project?.info?.project_type?.parent?.name || '';
			const categoryName = this.project?.info?.project_type?.category?.name || '';

			if (parentName && categoryName) {
					return `${categoryName} | ${parentName}`;
			}
			return parentName || categoryName || '';
		},
		currentColor: {
			get() {
				return this.colors[this.activeColorKey]
			},
			set(value) {
				this.$store.commit('costbreakdown/setCostTableColorMap', {
					[this.activeColorKey]: value
				});
			}
		},
		colors(){
			return this.$store.state.costbreakdown.costTableColorMap
		},
		subcontractConfigTableColor() {
			return this.$store.state.costbreakdown.costTableColorMap.subcontractConfigTableColor;
		},
		subcontractConfigTableColorSubheader(){
			return this.$store.state.costbreakdown.costTableColorMap.subcontractConfigTableColorSubheader;
		},
		costsPayments(){
			return this.costsTable.payments.map(p => ({
				...p,
				subcontract_stage_title: p.stage?.subcontract_stage_detail?.title
			})) || [];
		},
		projectPlannedStages(){
			const stagesNeedingPayment = (this.project.planning?.planning_categories || [])
																		.flatMap(category => category.stages || [])
																		.filter(stage => stage.needs_payment)
			return stagesNeedingPayment
		},
		projectLineAssociations(){
			if(this.project.associations?.associations){
				const project_associations = this.project.associations
				return project_associations.associations.map((association) => {
					return {...association, ...{type_name: this.getAssociationType(association.morphable_type)}}
				})
			}
			return []
		},
		summarySubcontractInfo() {
			let summary = {
				reception: null,
				stages: [],
				specialties: [],
				mainProjects: [],
				tax: this.costsTable.tax
			};

			// Agregar main projects desde costTableSubcontractinfo con project_table desde summaryInfo
			if (this.summaryInfo?.mainProjects && Array.isArray(this.summaryInfo.mainProjects) && Array.isArray(this.costTableSubcontractinfo)) {
				this.costTableSubcontractinfo.forEach(costTableInfo => {
					const mainProject = this.summaryInfo.mainProjects.find(mp => mp?.project_table?.id === costTableInfo.item_id);
					if (mainProject && mainProject.project_table) {
						const total_cost_config = costTableInfo.subcontract ? this.getAllPaymentPercentValues('cost_table', mainProject.project_table.id, costTableInfo.subcontract.id):0
						summary.mainProjects.push({
							...costTableInfo,
							project_table: mainProject.project_table,
							total_cost_config
						});
					}
				});
			}

			// Agregar stages desde stagesSubcontractinfo con project_table desde summaryInfo
			if (this.summaryInfo?.stages && Array.isArray(this.summaryInfo.stages) && Array.isArray(this.stagesSubcontractinfo)) {
				this.stagesSubcontractinfo.forEach(stage => {
					const stageInfo = this.summaryInfo.stages.find(s => s?.id === stage.item_id);
					const total_cost_config = stage.subcontract ? this.getAllPaymentPercentValues('stage', stage.item_id, stage.subcontract.id):0
					if (stageInfo && stageInfo.project_table) {
						summary.stages.push({
							...stage,
							stage: stageInfo,
							project_table: stageInfo.project_table,
							total_cost_config
						});
					}
				});
			}

			// Agregar specialties desde specialtiesSubcontractinfo con project_table desde summaryInfo
			if (this.summaryInfo?.specialties && Array.isArray(this.summaryInfo.specialties) && Array.isArray(this.specialtiesSubcontractinfo)) {
				this.specialtiesSubcontractinfo.forEach(specialty => {
					const specialtyInfo = this.summaryInfo.specialties.find(sp => sp?.id === specialty.item_id);
					const total_cost_config = specialty.subcontract ? this.getAllPaymentPercentValues('specialty', specialty.item_id, specialty.subcontract.id):0
					if (specialtyInfo && specialtyInfo.project_table) {
						summary.specialties.push({
							...specialty,
							specialty: specialtyInfo,
							project_table: specialtyInfo.project_table,
							total_cost_config
						});
					}
				});
			}

			// Agregar reception si existe
			if (this.receptionSubcontractinfo && this.summaryInfo?.reception?.project_table) {
				const total_cost_config = this.receptionSubcontractinfo.subcontract ? this.getAllPaymentPercentValues('reception', this.receptionSubcontractinfo.item_id, this.receptionSubcontractinfo.subcontract.id):0
				summary.reception = {
					...this.receptionSubcontractinfo,
					project_table: this.summaryInfo.reception.project_table,
					total_cost_config
				};
			}
			console.log('[DEBUG] summarySubcontractInfo', summary)
			return summary;
		},
		totalProjectCostSummary() {
			let total = {
				total_cost_uf: 0,
				tax_value_uf: 0,
				total_cost_uf_taxed: 0,
				total_cost_clp: 0,
				tax_value_clp: 0,
				total_cost_clp_taxed: 0
			};

			// Sumar mainProjects
			this.summarySubcontractInfo.mainProjects.forEach(mainProject => {
				const values = getParentItemTotalValueMultiWithTax([mainProject.project_table, mainProject.surfaces], mainProject.project_table?.tax, mainProject.project_table?.uf_value?.uf_value);
				total.total_cost_uf += values.total_cost_uf || 0;
				total.tax_value_uf += values.tax_value_uf || 0;
				total.total_cost_uf_taxed += values.total_cost_uf_taxed || 0;
				total.total_cost_clp += values.total_cost_clp || 0;
				total.tax_value_clp += values.tax_value_clp || 0;
				total.total_cost_clp_taxed += values.total_cost_clp_taxed || 0;
			});

			// Sumar stages
			this.summarySubcontractInfo.stages.forEach(stage => {
				const values = getParentItemTotalValueWithTax(stage, stage?.project_table?.tax, stage?.project_table?.uf_value?.uf_value);
				total.total_cost_uf += values.total_cost_uf || 0;
				total.tax_value_uf += values.tax_value_uf || 0;
				total.total_cost_uf_taxed += values.total_cost_uf_taxed || 0;
				total.total_cost_clp += values.total_cost_clp || 0;
				total.tax_value_clp += values.tax_value_clp || 0;
				total.total_cost_clp_taxed += values.total_cost_clp_taxed || 0;
			});

			// Sumar specialties
			this.summarySubcontractInfo.specialties.forEach(specialty => {
				const values = getParentItemTotalValueWithTax(specialty, specialty?.project_table?.tax, specialty?.project_table?.uf_value?.uf_value);
				total.total_cost_uf += values.total_cost_uf || 0;
				total.tax_value_uf += values.tax_value_uf || 0;
				total.total_cost_uf_taxed += values.total_cost_uf_taxed || 0;
				total.total_cost_clp += values.total_cost_clp || 0;
				total.tax_value_clp += values.tax_value_clp || 0;
				total.total_cost_clp_taxed += values.total_cost_clp_taxed || 0;
			});

			// Sumar reception si existe
			if (this.summarySubcontractInfo.reception) {
				const values = getParentItemTotalValueWithTax(this.summaryInfo.reception, this.summaryInfo.reception?.project_table?.tax, this.summaryInfo.reception?.project_table?.uf_value?.uf_value);
				total.total_cost_uf += values.total_cost_uf || 0;
				total.tax_value_uf += values.tax_value_uf || 0;
				total.total_cost_uf_taxed += values.total_cost_uf_taxed || 0;
				total.total_cost_clp += values.total_cost_clp || 0;
				total.tax_value_clp += values.tax_value_clp || 0;
				total.total_cost_clp_taxed += values.total_cost_clp_taxed || 0;
			}

			return total;
		},
		totalMainArqProject(){
			// Calcular el total del proyecto principal basándose en summarySubcontractInfo.mainProjects
			if (this.summarySubcontractInfo.mainProjects.length > 0) {
				const mainProject = this.summarySubcontractInfo.mainProjects[0];
				const values = getParentItemTotalValueMultiWithTax([mainProject.project_table, mainProject.project_table?.surfaces], this.costsTable.tax);
				return values;
			}
			// Fallback al comportamiento original si no hay datos
			const values = getParentItemTotalValueMultiWithTax([this.costsTable, this.costsTable.surfaces], this.costsTable.tax);
			return values;
		},
		receptionTotalCostSummary() {
			if (this.summarySubcontractInfo.reception) {
				const values = getParentItemTotalValueWithTax(this.summarySubcontractInfo.reception.project_table.reception, this.costsTable.tax);
				return values;
			}
			// Fallback al comportamiento original
			const values = getParentItemTotalValueWithTax(this.costsTable.reception, this.costsTable.tax);
			return values;
		},
		selectedCompany(){
			return this.$store.state.companies.selectedCompany
		},
		dayUfValue(){
			return this.$store.state.general.dayUfValue
		},
		companyCostSpecialties(){
			return this.$store.state.costbreakdown.companiesCostCategories
		},
		companySpecialties(){
			return this.$store.state.costbreakdown.companiesSpecialties
		},
		costProjects(){
			return this.$store.state.costbreakdown.companiesBaseProjects
		},
		costSpecialties(){
			return this.$store.state.costbreakdown.companiesCostSpecialties
		},
		costGeneralSubCategories(){
			return this.$store.state.costbreakdown.companiesCostGeneralSubCategories
		},
		orderedBySubcontract(){
			const subcontractMap = new Map();
			let shouldShowAnulatedSubcontracts = this.showAnulatedSubcontracts;

			const getSubcontractData = (element, activeSubcontractInfo = null) => {
				const activeSubcontract = element?.subcontract || activeSubcontractInfo?.subcontract;
				const hasActiveSubcontract = !!(activeSubcontract?.contract?.id);
				const hasAnnulatedSubcontract = !!(element?.annulated_subcontract?.contract?.id);
				
				return {
					hasActiveSubcontract,
					hasAnnulatedSubcontract,
					activeSubcontract: hasActiveSubcontract ? activeSubcontract : null,
					annulatedSubcontract: hasAnnulatedSubcontract ? element.annulated_subcontract : null
				};
			};
			
			const noSubcontractGroup = {
				subcontract: null,
				subcontract_info: null,
				items: {
					mainProjects: [],
					stages: [],
					specialties: [],
					reception: null
				}
			};
			this.summarySubcontractInfo.mainProjects.forEach(mainProject => {
				console.log('[DEBUG] - mainProject:', mainProject)
				
				const isAnnulatedRecord = mainProject._isAnnulatedRecord === true;

				// Normalizar el array de subcontratos anulados de este registro.
				// Cada entrada de annulated_subcontracts_info tiene su/s subcontrato/s en
				// `annulated_subcontract` (array). Si no existe, se cae sobre `subcontract` como fallback.
				const annulatedSubsArray = Array.isArray(mainProject.annulated_subcontract)
					? mainProject.annulated_subcontract
					: (mainProject.annulated_subcontract
						? [mainProject.annulated_subcontract]
						: (mainProject.subcontract?.contract?.id && isAnnulatedRecord ? [mainProject.subcontract] : []));

				// Verificar si algún subcontrato anulado tiene request de restauración pendiente
				annulatedSubsArray.forEach(annulatedSub => {
					const statusReq = annulatedSub?.contract?.status_requests?.[0];
					if (statusReq && statusReq.status === 0 && !this.userHasChangeAnnulatedSubcontractShow) {
						shouldShowAnulatedSubcontracts = true;
					}
				});
				
				if (isAnnulatedRecord) {
					// Este registro proviene de annulated_subcontracts_info.
					// Los objetos de subcontrato para los grupos anulados están en annulatedSubsArray.
					
					if (annulatedSubsArray.length === 0) return;

					// Agregar a cada grupo anulado correspondiente
					if (shouldShowAnulatedSubcontracts) {
						annulatedSubsArray.forEach(annulatedSub => {
							if (!annulatedSub?.contract?.id) return;
							const annulatedKey = `${annulatedSub.contract.id}_anulated`;
							if (!subcontractMap.has(annulatedKey)) {
								subcontractMap.set(annulatedKey, {
									subcontract: annulatedSub,
									subcontractType: 'anulated',
									subcontract_info: mainProject,
									items: {
										mainProjects: [],
										stages: [],
										specialties: [],
										reception: null
									}
								});
							}
							subcontractMap.get(annulatedKey).items.mainProjects.push(mainProject);
						});
					}
					
					// Solo agregar al noSubcontractGroup si el item NO tiene subcontrato activo.
					// Si tiene activo, el registro _isAnnulatedRecord:false ya fue al grupo activo,
					// y NO debe aparecer también en noSubcontractGroup.
					const activeSubcontractOnTable = mainProject.project_table?.subcontracts_info?.cost_table?.subcontract;
					const hasActiveSubcontractForThisItem = !!(activeSubcontractOnTable?.contract?.id);

					if (!hasActiveSubcontractForThisItem) {
						const foundMainProjectIndex = noSubcontractGroup.items.mainProjects.findIndex(mp => mp.item_id == mainProject.item_id)
						if (foundMainProjectIndex === -1) {
							const empty_item = {
								cost_value_clp: mainProject.cost_value_clp,
								cost_value_uf: mainProject.cost_value_uf,
								item_id: mainProject.item_id,
								item_type: mainProject.item_type,
								payments: mainProject.payments,
								project_table: mainProject.project_table,
							}
							noSubcontractGroup.items.mainProjects.push(empty_item);
						}
					}
				} else {
					// Este registro proviene de subcontracts_info (estado actual).
					// su `subcontract` es el activo (o null si no hay activo).
					const activeSubcontract = mainProject.subcontract?.contract?.id ? mainProject.subcontract : null;
					const hasActiveSubcontract = !!activeSubcontract;
					const subcontractInfo = mainProject.project_table?.subcontracts_info?.cost_table;
					
					// Caso 1: Sin subcontrato activo → noSubcontractGroup con objeto completo
					if (!hasActiveSubcontract) {
						console.log('[DEBUG] caso 1 mainProject sin contrato activo:', mainProject)
						const foundMainProjectIndex = noSubcontractGroup.items.mainProjects.findIndex(mp => mp.item_id == mainProject.item_id)
						if (foundMainProjectIndex !== -1) {
							noSubcontractGroup.items.mainProjects[foundMainProjectIndex] = mainProject;
						} else {
							noSubcontractGroup.items.mainProjects.push(mainProject);
						}
					}
					// Caso 2: Con subcontrato activo → grupo activo
					else {
						console.log('[DEBUG] caso 2 mainProject con contrato activo:', mainProject, activeSubcontract)
						const activeKey = `${activeSubcontract.contract.id}_active`;
						if (!subcontractMap.has(activeKey)) {
							subcontractMap.set(activeKey, {
								subcontract: activeSubcontract,
								subcontractType: 'active',
								subcontract_info: subcontractInfo,
								items: {
									mainProjects: [],
									stages: [],
									specialties: [],
									reception: null
								}
							});
						}
						subcontractMap.get(activeKey).items.mainProjects.push(mainProject);
					}
				}
			});
			this.summarySubcontractInfo.stages.forEach(stage => {
				const stageSubcontractInfo =
					stage.project_table?.subcontracts_info?.stages?.find(s => s.id === stage.id)
					|| this.costsTable.subcontracts_info?.stages?.find(s => s.id === stage.id);
				const annulatedStageSubcontractInfo =
					stage.project_table?.annulated_subcontracts_info?.stages?.find(s => s.id === stage.id)
					|| this.costsTable.annulated_subcontracts_info?.stages?.find(s => s.id === stage.id);
				
				const { hasActiveSubcontract, hasAnnulatedSubcontract, activeSubcontract, annulatedSubcontract } = 
					getSubcontractData(stage, stageSubcontractInfo);

				const currentStatusRequest = annulatedSubcontract?.contract?.status_requests?.[0];
				const hasStatusRequest = currentStatusRequest && currentStatusRequest.status === 0;
				if (hasStatusRequest && !this.userHasChangeAnnulatedSubcontractShow) {
					shouldShowAnulatedSubcontracts = true;
				}

				// Caso 1: No tiene ninguno o son null
				if (!hasActiveSubcontract && !hasAnnulatedSubcontract) {
					noSubcontractGroup.items.stages.push(stage);
				}
				// Caso 2: Tiene solo contrato activo
				else if (hasActiveSubcontract && !hasAnnulatedSubcontract) {
					const key = `${activeSubcontract.contract.id}_active`;
					if (!subcontractMap.has(key)) {
						subcontractMap.set(key, {
							subcontract: activeSubcontract,
							subcontractType: 'active',
							subcontract_info: stageSubcontractInfo,
							items: {
								mainProjects: [],
								stages: [],
								specialties: [],
								reception: null
							}
						});
					}
					if(stage.id == stageSubcontractInfo.id){
						subcontractMap.get(key).items.stages.push(stage);
					}
				}
				// Caso 3: Tiene contrato anulado y contrato activo
				else if (hasActiveSubcontract && hasAnnulatedSubcontract) {
					if (shouldShowAnulatedSubcontracts) {
						// Agregar a grupo de contrato anulado con type 'anulated'
						const annulatedKey = `${annulatedSubcontract.contract.id}_anulated`;
						if (!subcontractMap.has(annulatedKey)) {
							subcontractMap.set(annulatedKey, {
								subcontract: annulatedSubcontract,
								subcontractType: 'anulated',
								subcontract_info: annulatedStageSubcontractInfo,
								items: {
									mainProjects: [],
									stages: [],
									specialties: [],
									reception: null
								}
							});
						}
						if(stage.id == annulatedStageSubcontractInfo.id){
							subcontractMap.get(annulatedKey).items.stages.push(stage);
						}
					}
					// Agregar a grupo de contrato activo solo si el stage pertenece a ese subcontrato
					if(stage.id == stageSubcontractInfo.id){
						const activeKey = `${activeSubcontract.contract.id}_active`;
						if (!subcontractMap.has(activeKey)) {
							subcontractMap.set(activeKey, {
								subcontract: activeSubcontract,
								subcontractType: 'active',
								subcontract_info: stageSubcontractInfo,
								items: {
									mainProjects: [],
									stages: [],
									specialties: [],
									reception: null
								}
							});
						}
						subcontractMap.get(activeKey).items.stages.push(stage);
					}
				}
				// Caso 4: Tiene contrato anulado y no contrato activo
				else if (!hasActiveSubcontract && hasAnnulatedSubcontract) {
					if (shouldShowAnulatedSubcontracts) {
						// Agregar a grupo de contrato anulado
						const annulatedKey = `${annulatedSubcontract.contract.id}_anulated`;
						if (!subcontractMap.has(annulatedKey)) {
							subcontractMap.set(annulatedKey, {
								subcontract: annulatedSubcontract,
								subcontractType: 'anulated',
								subcontract_info: annulatedStageSubcontractInfo,
								items: {
									mainProjects: [],
									stages: [],
									specialties: [],
									reception: null
								}
							});
						}
						if(stage.id == annulatedStageSubcontractInfo.id){
							subcontractMap.get(annulatedKey).items.stages.push(stage);
						}
					}
					const empty_item = {
						cost_value_clp: stage.cost_value_clp,
						cost_value_uf: stage.cost_value_uf,
						item_id: stage.item_id,
						item_type: stage.item_type,
						payments: stage.payments,
						project_table: stage.project_table,
						stage: stage.stage
					}
					const foundIndex = noSubcontractGroup.items.stages.findIndex(s => stage.item_id == s.item_id)
					if(foundIndex != -1){
						noSubcontractGroup.items.stages[foundIndex] = empty_item;
					}
					else{
						noSubcontractGroup.items.stages.push(empty_item);
					}
				}
			});
			this.summarySubcontractInfo.specialties.forEach(specialty => {
				const specialtySubcontractInfo =
					specialty.project_table?.subcontracts_info?.specialties?.find(s => s.id === specialty.id)
					|| this.costsTable.subcontracts_info?.specialties?.find(s => s.id === specialty.id);
				const annulatedSpecialtySubcontractInfo =
					specialty.project_table?.annulated_subcontracts_info?.specialties?.find(s => s.id === specialty.id)
					|| this.costsTable.annulated_subcontracts_info?.specialties?.find(s => s.id === specialty.id);
				
				const { hasActiveSubcontract, hasAnnulatedSubcontract, activeSubcontract, annulatedSubcontract } = 
					getSubcontractData(specialty, specialtySubcontractInfo);
					
				const currentStatusRequest = annulatedSubcontract?.contract?.status_requests?.[0];
				const hasStatusRequest = currentStatusRequest && currentStatusRequest.status === 0;
				if (hasStatusRequest && !this.userHasChangeAnnulatedSubcontractShow) {
					shouldShowAnulatedSubcontracts = true;
				}

				// Caso 1: No tiene ninguno o son null
				if (!hasActiveSubcontract && !hasAnnulatedSubcontract) {
					noSubcontractGroup.items.specialties.push(specialty);
				}
				// Caso 2: Tiene solo contrato activo
				else if (hasActiveSubcontract && !hasAnnulatedSubcontract) {
					const key = `${activeSubcontract.contract.id}_active`;
					if (!subcontractMap.has(key)) {
						subcontractMap.set(key, {
							subcontract: activeSubcontract,
							subcontractType: 'active',
							subcontract_info: specialtySubcontractInfo,
							items: {
								mainProjects: [],
								stages: [],
								specialties: [],
								reception: null
							}
						});
					}
					if(specialty.id == specialtySubcontractInfo.id){
						subcontractMap.get(key).items.specialties.push(specialty);
					}
				}
				// Caso 3: Tiene contrato anulado y contrato activo
				else if (hasActiveSubcontract && hasAnnulatedSubcontract) {
					if (shouldShowAnulatedSubcontracts) {
						const annulatedKey = `${annulatedSubcontract.contract.id}_anulated`;
						if (!subcontractMap.has(annulatedKey)) {
							subcontractMap.set(annulatedKey, {
								subcontract: annulatedSubcontract,
								subcontractType: 'anulated',
								subcontract_info: annulatedSpecialtySubcontractInfo,
								items: {
									mainProjects: [],
									stages: [],
									specialties: [],
									reception: null
								}
							});
						}
						if(specialty.id == annulatedSpecialtySubcontractInfo.id){
							subcontractMap.get(annulatedKey).items.specialties.push(specialty);
						}
					}
					// Agregar a grupo de contrato activo solo si la specialty pertenece a ese subcontrato
					if(specialty.id == specialtySubcontractInfo.id){
						const activeKey = `${activeSubcontract.contract.id}_active`;
						if (!subcontractMap.has(activeKey)) {
							subcontractMap.set(activeKey, {
								subcontract: activeSubcontract,
								subcontractType: 'active',
								subcontract_info: specialtySubcontractInfo,
								items: {
									mainProjects: [],
									stages: [],
									specialties: [],
									reception: null
								}
							});
						}
						subcontractMap.get(activeKey).items.specialties.push(specialty);
					}
				}
				// Caso 4: Tiene contrato anulado y no contrato activo
				else if (!hasActiveSubcontract && hasAnnulatedSubcontract) {
					if (shouldShowAnulatedSubcontracts) {
						// Agregar a grupo de contrato anulado
						const annulatedKey = `${annulatedSubcontract.contract.id}_anulated`;
						if (!subcontractMap.has(annulatedKey)) {
							subcontractMap.set(annulatedKey, {
								subcontract: annulatedSubcontract,
								subcontractType: 'anulated',
								subcontract_info: annulatedSpecialtySubcontractInfo,
								items: {
									mainProjects: [],
									stages: [],
									specialties: [],
									reception: null
								}
							});
						}
						if(specialty.id == annulatedSpecialtySubcontractInfo.id){
							subcontractMap.get(annulatedKey).items.specialties.push(specialty);
						}
					}
					const empty_item = {
						cost_value_clp: specialty.cost_value_clp,
						cost_value_uf: specialty.cost_value_uf,
						item_id: specialty.item_id,
						item_type: specialty.item_type,
						payments: specialty.payments,
						project_table: specialty.project_table,
						specialty: specialty.specialty
					}
					const foundIndex = noSubcontractGroup.items.specialties.findIndex(s => specialty.item_id == s.item_id)
					if(foundIndex != -1){
						noSubcontractGroup.items.specialties[foundIndex] = empty_item;
					}
					else{
						noSubcontractGroup.items.specialties.push(empty_item);
					}
				}
			});
			if (this.summarySubcontractInfo.reception) {
				// console.log('[DEBUG] - receptionSubcontractInfo:', this.summarySubcontractInfo.reception)
				const receptionSubcontractInfo = this.summarySubcontractInfo.reception;
				const annulatedReceptionSubcontractInfoArray = Array.isArray(receptionSubcontractInfo.project_table?.annulated_subcontracts_info?.reception) 
					? receptionSubcontractInfo.project_table.annulated_subcontracts_info.reception 
					: (receptionSubcontractInfo.project_table?.annulated_subcontracts_info?.reception ? [receptionSubcontractInfo.project_table.annulated_subcontracts_info.reception] : []);
				// console.log('[DEBUG] - annulatedReceptionSubcontractInfoArray:', annulatedReceptionSubcontractInfoArray)
				const { hasActiveSubcontract, activeSubcontract } = 
					getSubcontractData(receptionSubcontractInfo);
					
				// Comprobar si alguno de los reception anulados tiene request pendiente
				let shouldShowAnulatedForThisReception = false;
				annulatedReceptionSubcontractInfoArray.forEach(annulatedItem => {
					annulatedItem.annulated_subcontract?.forEach(annulatedSub => {
						const currentStatusRequest = annulatedSub?.contract?.status_requests?.[0];
						if (currentStatusRequest && currentStatusRequest.status === 0) {
							shouldShowAnulatedForThisReception = true;
						}
					});
				});
				
				if (shouldShowAnulatedForThisReception && !this.userHasChangeAnnulatedSubcontractShow) {
					shouldShowAnulatedSubcontracts = true;
				}
				
				// Caso 1: No tiene ninguno o son null
				if (!hasActiveSubcontract && annulatedReceptionSubcontractInfoArray.length === 0) {
					// console.log('[DEBUG] - Caso 1: reception has no active subcontract and no annulated subcontracts')
					noSubcontractGroup.items.reception = { ...receptionSubcontractInfo, item_id: receptionSubcontractInfo.item_id, item_type: 'reception' };
				}
				// Caso 2: Tiene solo contrato activo
				else if (hasActiveSubcontract && annulatedReceptionSubcontractInfoArray.length === 0) {
					// console.log('[DEBUG] - Caso 2: reception has active subcontract and no annulated subcontracts')
					const key = `${activeSubcontract.contract.id}_active`;
					if (!subcontractMap.has(key)) {
						subcontractMap.set(key, {
							subcontract: activeSubcontract,
							subcontractType: 'active',
							subcontract_info: receptionSubcontractInfo,
							items: {
								mainProjects: [],
								stages: [],
								specialties: [],
								reception: null
							}
						});
					}
					if(receptionSubcontractInfo && receptionSubcontractInfo.id){
						subcontractMap.get(key).items.reception = { ...receptionSubcontractInfo, item_id: receptionSubcontractInfo.item_id, item_type: 'reception' };
					}
				}
				// Caso 3: Tiene contrato anulado(s) y contrato activo
				else if (hasActiveSubcontract && annulatedReceptionSubcontractInfoArray.length > 0) {
					// console.log('[DEBUG] - Caso 3: reception has active subcontract and annulated subcontracts')
					// Procesar múltiples reception anulados
					annulatedReceptionSubcontractInfoArray.forEach(annulatedItem => {
						// Procesar cada reception anulado dentro del item
						annulatedItem.annulated_subcontract?.forEach(annulatedSubcontract => {
							if (shouldShowAnulatedSubcontracts) {
								const annulatedKey = `${annulatedSubcontract.contract.id}_anulated`;
								if (!subcontractMap.has(annulatedKey)) {
									subcontractMap.set(annulatedKey, {
										subcontract: annulatedSubcontract,
										subcontractType: 'anulated',
										subcontract_info: annulatedItem,
										items: {
											mainProjects: [],
											stages: [],
											specialties: [],
											reception: null
										}
									});
								}
								subcontractMap.get(annulatedKey).items.reception = { ...receptionSubcontractInfo, item_id: receptionSubcontractInfo.item_id, item_type: 'reception' };
							}
						});
					});
					
					// Siempre agregar a grupo de contrato activo
					if(receptionSubcontractInfo && receptionSubcontractInfo.id){
						const activeKey = `${activeSubcontract.contract.id}_active`;
						if (!subcontractMap.has(activeKey)) {
							subcontractMap.set(activeKey, {
								subcontract: activeSubcontract,
								subcontractType: 'active',
								subcontract_info: receptionSubcontractInfo,
								items: {
									mainProjects: [],
									stages: [],
									specialties: [],
									reception: null
								}
							});
						}
						subcontractMap.get(activeKey).items.reception = { ...receptionSubcontractInfo, item_id: receptionSubcontractInfo.item_id, item_type: 'reception' };
					}
				}
				// Caso 4: Tiene contrato anulado(s) y no contrato activo
				else if (!hasActiveSubcontract && annulatedReceptionSubcontractInfoArray.length > 0) {
					// console.log('[DEBUG] - Caso 4: reception has no active subcontract and has annulated subcontracts')
					if (shouldShowAnulatedSubcontracts) {
						annulatedReceptionSubcontractInfoArray.forEach(annulatedItem => {
							// Procesar cada reception anulado dentro del item
							annulatedItem.annulated_subcontract?.forEach(annulatedSubcontract => {
								const annulatedKey = `${annulatedSubcontract.contract.id}_anulated`;
								if (!subcontractMap.has(annulatedKey)) {
									subcontractMap.set(annulatedKey, {
										subcontract: annulatedSubcontract,
										subcontractType: 'anulated',
										subcontract_info: annulatedItem,
										items: {
											mainProjects: [],
											stages: [],
											specialties: [],
											reception: null
										}
									});
								}
								subcontractMap.get(annulatedKey).items.reception = { ...receptionSubcontractInfo, item_id: receptionSubcontractInfo.id, item_type: 'reception' };
							});
						});
					}
					const empty_item = {
						cost_value_clp: receptionSubcontractInfo.cost_value_clp,
						cost_value_uf: receptionSubcontractInfo.cost_value_uf,
						item_id: receptionSubcontractInfo.item_id,
						item_type: receptionSubcontractInfo.item_type,
						payments: receptionSubcontractInfo.payments,
						project_table: receptionSubcontractInfo.project_table,
					}
					noSubcontractGroup.items.reception = empty_item
				}
			}
			const ordered = Array.from(subcontractMap.values()).sort((a, b) => {
				return (a.subcontract?.id || 0) - (b.subcontract?.id || 0);
			});

			if (noSubcontractGroup.items.mainProjects.length > 0 ||
					noSubcontractGroup.items.stages.length > 0 ||
					noSubcontractGroup.items.specialties.length > 0 ||
					noSubcontractGroup.items.reception) {
				ordered.push(noSubcontractGroup);
			}
			let finalOrder = ordered.map(item => ({
				...item,
				type: item.subcontractType || 'none'
			}));
			if(this.isSubcontractor){
				const user = this.$store.state.user.userInfo
				finalOrder = finalOrder.filter(group => {
					return group.subcontract?.contractor_id == user.id;
				});
			}
			// Update the reactive property once at the end
			this.$nextTick(() => {
				this.showAnulatedSubcontracts = shouldShowAnulatedSubcontracts;
			});

			finalOrder.forEach(order => {
				const allItems = Object.values(order.items)
					.flat()
					.filter(Boolean)
				order.has_all_payments =
					allItems.length > 0 &&
					allItems.every(
						item => Number(item.total_cost_config) === 100 && item.cost_value_uf > 0 && item.cost_value_clp > 0
					)
			})
			console.log('[DEBUG] finalOrder', finalOrder)
			return finalOrder;
		},
		summaryInfo(){
			let summary = {
				reception: null,
				surfaces: [],
				projects: [],
				stages: [],
				specialties: [],
				tax: this.costsTable.tax,
				mainProjects: (this.costsTable.reception || (Array.isArray(this.costsTable.surfaces?.items) && this.costsTable.surfaces.items.length > 0)) ? [{ 
					...{
						reception: this.costsTable.reception,
						surfaces: this.costsTable.surfaces
					},
					project_table: this.costsTable
				}] : []
			};
			
			// Agregar elementos del costsTable principal
			if (this.costsTable.reception) {
				summary.reception = { ...this.costsTable.reception, project_table: this.costsTable };
			}
			if (Array.isArray(this.costsTable.surfaces?.items)) {
				summary.surfaces.push(...this.costsTable.surfaces.items.map(item => ({ ...item, project_table: this.costsTable })));
			}
			if (Array.isArray(this.costsTable.projects)) {
				summary.projects.push(...this.costsTable.projects.map(item => ({ ...item, project_table: this.costsTable })));
			}
			if (Array.isArray(this.costsTable.stages)) {
				summary.stages.push(...this.costsTable.stages.map(item => ({ ...item, project_table: this.costsTable })));
			}
			if (Array.isArray(this.costsTable.specialties)) {
				summary.specialties.push(...this.costsTable.specialties.map(item => ({ ...item, project_table: this.costsTable })));
			}
			
			// Agregar elementos de las tablas adicionales
			this.project_tables.forEach(project_table => {
				if (project_table.reception) {
					summary.reception = { ...project_table.reception, project_table };
				}
				if (Array.isArray(project_table.surfaces?.items)) {
					summary.surfaces.push(...project_table.surfaces.items.map(item => ({ ...item, project_table })));
				}
				if (Array.isArray(project_table.projects)) {
					summary.projects.push(...project_table.projects.map(item => ({ ...item, project_table })));
				}
				if (Array.isArray(project_table.stages)) {
					summary.stages.push(...project_table.stages.map(item => ({ ...item, project_table })));
				}
				if (Array.isArray(project_table.specialties)) {
					summary.specialties.push(...project_table.specialties.map(item => ({ ...item, project_table })));
				}
				if (project_table.reception || (Array.isArray(project_table.surfaces?.items) && project_table.surfaces.items.length > 0)) {
					summary.mainProjects.push({ 
						...{
							reception: project_table.reception,
							surfaces: project_table.surfaces
						},
						project_table: project_table
					});
				}
			});
			console.log('[DEBUG] summaryInfo computed property:', summary);
			return summary;
		},
		costTableSubcontract(){
			return this.costsTable.subcontract
		},
		costTableSubcontractsInfo(){
			return this.costsTable.subcontracts_info
		},
		costTableStagesSubcontract(){
			return this.costsTable.stages?.filter(s => s.subcontract).length
		},
		costTableSpecialtiesSubcontract(){
			return this.costsTable.specialties.filter(s => s.subcontract).length
		},
		costTableReceptionSubcontract(){
			return this.costsTable.reception?.subcontract
		},
		subcontractCounter() {
			let counter = 0
			if (typeof this.costsTable.subcontract === 'boolean') counter += this.costsTable.subcontract ? 1 : 0
			if (Array.isArray(this.costsTable.stages)) {
				counter += this.costsTable.stages.filter(s => s.subcontract === true).length
			}
			if (Array.isArray(this.costsTable.specialties)) {
				counter += this.costsTable.specialties.filter(s => s.subcontract === true).length
			}
			if (this.costsTable.reception && typeof this.costsTable.reception.subcontract === 'boolean') {
				counter += this.costsTable.reception.subcontract ? 1 : 0
			}
			// Contar elementos de tablas secundarias (project_tables)
			if (Array.isArray(this.costsTable.project_tables)) {
				this.costsTable.project_tables.forEach(projectTable => {
					if (typeof projectTable.subcontract === 'boolean') counter += projectTable.subcontract ? 1 : 0
					if (Array.isArray(projectTable.stages)) {
						counter += projectTable.stages.filter(s => s.subcontract === true).length
					}
					if (Array.isArray(projectTable.specialties)) {
						counter += projectTable.specialties.filter(s => s.subcontract === true).length
					}
					if (projectTable.reception && typeof projectTable.reception.subcontract === 'boolean') {
						counter += projectTable.reception.subcontract ? 1 : 0
					}
				})
			}
			return counter
		},
		allSubcontractTables() {
			const tables = new Set();
			this.summarySubcontractInfo.mainProjects.forEach(mp => tables.add(mp.project_table));
			this.summarySubcontractInfo.stages.forEach(s => tables.add(s.project_table));
			this.summarySubcontractInfo.specialties.forEach(sp => tables.add(sp.project_table));
			if (this.summarySubcontractInfo.reception) tables.add(this.summarySubcontractInfo.reception.project_table);
			return Array.from(tables);
		},
		nextSubpayment(){
			if (!Array.isArray(this.costsPayments)) return false;
			
			for (const costsPayment of this.costsPayments) {
				if (costsPayment.subcontract_payments?.length) {
					for (const subcontractPayment of costsPayment.subcontract_payments) {
						if (subcontractPayment.subpayments?.length) {
							const subPayment = subcontractPayment.subpayments.find(subPayment => 
								subPayment?.payment_order?.some(order => !order.payment_info)
							);
							if (subPayment) return subPayment;
						}
					}
				}
			}
			
			return false;
		},
		subcontractorList(){
			return this.$store.state.users.usersList.filter(user => {
				return user.company_rol?.capabilities?.subcontractor === true
			})
		},
		subcontractorsForChat(){
			return this.subcontractorList.map(user => {
				return {
					...user,
					userType: 'subcontractor'
				}
			})
		}
	},
	watch: {
		addAdditionalAmountId(){
			this.redrawLeaderLines()
		},
		costsTable: {
			handler(newVal, oldVal) {
				// console.log('[DEBUG] - costsTable changed, comparing newVal and oldVal for contract ID changes');
				if (!newVal || !oldVal) return;
				
				let contractIdChanged = false;
				
				const extractContractData = (obj) => {
					const contracts = [];
					
					if (!obj) return contracts;
					
					if (obj.subcontracts_info) {
						// Manejar cost_table que puede ser objeto o array
						if (obj.subcontracts_info?.cost_table) {
							if (Array.isArray(obj.subcontracts_info.cost_table)) {
								obj.subcontracts_info.cost_table.forEach(item => {
									if (item?.subcontract?.contract) {
										contracts.push({
											id: item.subcontract.contract.id,
											lastStatus: item.subcontract.contract.last_status?.status
										});
									}
								});
							} else {
								if (obj.subcontracts_info?.cost_table?.subcontract?.contract) {
									contracts.push({
										id: obj.subcontracts_info.cost_table.subcontract.contract.id,
										lastStatus: obj.subcontracts_info.cost_table.subcontract.contract.last_status?.status
									});
								}
							}
						}
						
						if (obj.subcontracts_info?.reception?.subcontract?.contract) {
							contracts.push({
								id: obj.subcontracts_info.reception.subcontract.contract.id,
								lastStatus: obj.subcontracts_info.reception.subcontract.contract.last_status?.status
							});
						}
						
						(obj.subcontracts_info.specialties || []).forEach(item => {
							if (item?.subcontract?.contract) {
								contracts.push({
									id: item.subcontract.contract.id,
									lastStatus: item.subcontract.contract.last_status?.status
								});
							}
						});
						(obj.subcontracts_info.stages || []).forEach(item => {
							if (item?.subcontract?.contract) {
								contracts.push({
									id: item.subcontract.contract.id,
									lastStatus: item.subcontract.contract.last_status?.status
								});
							}
						});
					}
					
					if (obj.project_tables && Array.isArray(obj.project_tables)) {
						obj.project_tables.forEach(projectTable => {
							if (projectTable?.subcontracts_info) {
								// Manejar cost_table que puede ser objeto o array
								if (projectTable.subcontracts_info?.cost_table) {
									if (Array.isArray(projectTable.subcontracts_info.cost_table)) {
										projectTable.subcontracts_info.cost_table.forEach(item => {
											if (item?.subcontract?.contract) {
												contracts.push({
													id: item.subcontract.contract.id,
													lastStatus: item.subcontract.contract.last_status?.status
												});
											}
										});
									} else {
										if (projectTable.subcontracts_info?.cost_table?.subcontract?.contract) {
											contracts.push({
												id: projectTable.subcontracts_info.cost_table.subcontract.contract.id,
												lastStatus: projectTable.subcontracts_info.cost_table.subcontract.contract.last_status?.status
											});
										}
									}
								}
								
								if (projectTable.subcontracts_info?.reception?.subcontract?.contract) {
									contracts.push({
										id: projectTable.subcontracts_info.reception.subcontract.contract.id,
										lastStatus: projectTable.subcontracts_info.reception.subcontract.contract.last_status?.status
									});
								}
								
								(projectTable.subcontracts_info.specialties || []).forEach(item => {
									if (item?.subcontract?.contract) {
										contracts.push({
											id: item.subcontract.contract.id,
											lastStatus: item.subcontract.contract.last_status?.status
										});
									}
								});
								(projectTable.subcontracts_info.stages || []).forEach(item => {
									if (item?.subcontract?.contract) {
										contracts.push({
											id: item.subcontract.contract.id,
											lastStatus: item.subcontract.contract.last_status?.status
										});
									}
								});
							}
						});
					}
					
					return contracts;
				};

				const extractRestorationStates = (obj) => {
					const states = [];
					if (!obj) return states;

					const pushState = (contract) => {
						if (!contract) return;

						const currentStatus = contract.status_requests?.[0];
						states.push(
							currentStatus && currentStatus.status === 0
								? 'object'
								: 'null'
						);
					};

					const processSubcontractsInfo = (info, key) => {
						if (!info) return;

						const getContract = (item) => item?.[key]?.contract;

						// Manejar cost_table que ahora puede ser un array
						if (Array.isArray(info.cost_table)) {
							info.cost_table.forEach(item => {
								if (Array.isArray(item[key])) {
									item[key].forEach(contract => {
										pushState(contract.contract);
									});
								}
							});
						} else {
							pushState(getContract(info.cost_table));
						}
						
						pushState(getContract(info.reception));

						(info.specialties || []).forEach(item =>
							pushState(getContract(item))
						);

						(info.stages || []).forEach(item =>
							pushState(getContract(item))
						);
					};
					

					// root
					processSubcontractsInfo(obj.annulated_subcontracts_info, 'annulated_subcontract');
					processSubcontractsInfo(obj.subcontracts_info, 'subcontract');

					// project tables
					(obj.project_tables || []).forEach(pt => {
						processSubcontractsInfo(pt?.annulated_subcontracts_info, 'annulated_subcontract');
						processSubcontractsInfo(pt?.subcontracts_info, 'subcontract');
					});

					return states;
				};
				
				const newContractData = extractContractData(newVal);
				const oldContractData = extractContractData(oldVal);
				// console.log('[DEBUG] - newContractData:', newContractData);
				
				if (JSON.stringify(newContractData) !== JSON.stringify(oldContractData)) {
					contractIdChanged = true;
				}

				let shouldRecalculate = false;

				const newRestorationStates = extractRestorationStates(newVal);
				const oldRestorationStates = extractRestorationStates(oldVal);

				if (JSON.stringify(newRestorationStates) !== JSON.stringify(oldRestorationStates)) {
					shouldRecalculate = true;
				}
				if (contractIdChanged || shouldRecalculate || this.shouldRecalculateBaseValues) {
					this.updatingFromParent = true
					this.setBaseValues();
					this.shouldRecalculateBaseValues = false;
					this.$nextTick(() => {
						this.updatingFromParent = false
					})
				}
			},
			deep: true
		},
		costTableSubcontractsInfo: {
			handler(newVal, oldVal) {
				if (!newVal || !oldVal) return
				const costTableIdChanged = newVal.cost_table?.id !== oldVal.cost_table?.id
				const receptionIdChanged = newVal.reception?.id !== oldVal.reception?.id

				const stagesChanged = (newVal.stages || []).length !== (oldVal.stages || []).length ||
					(newVal.stages || []).some(stage => !(oldVal.stages || []).find(s => s.id === stage.id))
				const specialtiesChanged = (newVal.specialties || []).length !== (oldVal.specialties || []).length ||
					(newVal.specialties || []).some(spec => !(oldVal.specialties || []).find(s => s.id === spec.id))

				if (costTableIdChanged || receptionIdChanged || stagesChanged || specialtiesChanged) {
					this.setBaseValues()
				}
			},
			deep: true
		},
		subcontractCounter: {
			handler(newVal, oldVal) {
				if (this.subcontractCounter != oldVal) {
					this.setBaseValues()
				}
			},
			deep: true
		},
		ufValue: {
			handler(newValue) {
				if (newValue) {
					this.setBaseValues()
				}
			},
			deep: true
		},
		focusedTab(newVal) {
			this.$nextTick(() => {
				if(newVal ==  3){
					this.redrawLeaderLines()
				}
				else{
					if(this.lines && this.lines.length > 0){
						this.lines.forEach(line => {
							line.remove()
						});
						this.lines = [];
					}
				}
			});
		},
		orderedBySubcontract: {
			handler(newVal, oldVal) {
				if(newVal.length === 0 || this.focusedTab != 3) return;
				
				const itemsChanged = newVal.some((group, index) => {
					const oldGroup = oldVal?.[index];
					if (!oldGroup) return true;
					
					const newItems = group.items || {};
					const oldItems = oldGroup.items || {};
					
					return (
						(newItems.mainProjects || []).length !== (oldItems.mainProjects || []).length ||
						(newItems.specialties || []).length !== (oldItems.specialties || []).length ||
						(newItems.stages || []).length !== (oldItems.stages || []).length ||
						(newItems.reception ? 1 : 0) !== (oldItems.reception ? 1 : 0)
					);
				});
				
				if (!itemsChanged || (!this.lines || this.lines.length === 0)) return;
				
				// this.$nextTick(() => {
				// 	this.redrawLeaderLines();
				// 	// if(this.lines && this.lines.length > 0){
				// 	// 	this.lines.forEach(line => line.show('draw', {duration: 750}));
				// 	// }
				// 	// else{
				// 	// 	this.redrawLeaderLines();
				// 	// }
				// });
			},
			deep: true
		}
	},
	mounted(){
		this.showAnulatedSubcontracts = this.fromSubcontractor
		this.checkIfCostsPayments()
		if(this.costsTable){
			this.setBaseValues()
		}
		console.log('[DEBUG] - Mounted with ufValues:', this.ufValues)
		if(!this.ufValues || this.ufValues.length === 0){
			this.$store.dispatch('general/getPosteriorDaysUf')
		}
	},
	beforeDestroy(){
		if(this.lines && this.lines.length > 0){
			this.lines.forEach(line => line.remove());
			this.lines = [];
		}
		window.removeEventListener('scroll', this.updateLeaderLinePosition);
		document.removeEventListener('scroll', this.updateLeaderLinePosition, true);
	},
  methods: {
		async toSubcontractorChat(subcontract){
			if(!subcontract?.subcontract?.contractor_id) return;
			const user_chat = await createUserChatRoom({user_id: subcontract.subcontract.contractor_id})
			if(user_chat.code == 200){
				this.$store.commit('general/addChatRoomCenter', user_chat.chat_room)
				// window.open(
				// 	`/built-in-content?type=chatroom&id=${user_chat.chat_room.id}`,
				// 	'',
				// 	'width=550,height=700,toolbar=no,menubar=no,location=no,status=no'
				// );
			}
		},
		showSubcontractInfo(subcontract){
			return !subcontract?.has_all_payments && this.project.contract?.last_status?.status != contractStatuses.SUBCONTRATO_ANULADO && subcontract.subcontract_info?.contractor
		},
		updateSubcontractTaxUfInfo(){
			this.shouldRecalculateBaseValues = true;
		},
		getTaxValueFromSubcontract(subcontract){
			return subcontract.subcontract?.contract?.info?.tax || this.costsTable.tax
		},
		getTaxFromValue(valueWithoutTax, tax){
			if(tax.type == 1){
				return valueWithoutTax * (tax.value / 100);
			}
			else if(tax.type == 2){
				return this.getValueWithTax(valueWithoutTax, tax) - valueWithoutTax;
			}
		},
		getValueWithTax(valueWithoutTax, tax){
			if(tax.type == 1){
				return valueWithoutTax * (1 + (tax.value / 100));
			}
			else if(tax.type == 2){
				return valueWithoutTax / (1 - (tax.value / 100));
			}
		},
		hasAnulatedSubcontract(info){
			const annulatedInfo = this.costsTable.annulated_subcontracts_info && this.costsTable.annulated_subcontracts_info[info.item_type];
			// Manejar tanto objetos como arrays
			if (Array.isArray(annulatedInfo)) {
				return annulatedInfo.length > 0;
			}
			return !!annulatedInfo;
		},
		getProjectPaymentTotalValue(costsPayment, paymentProjectType, typeItemId){
			return costsPayment.subcontract_payments.find(p =>
				p.item_type == paymentProjectType &&
				p.type_item_id == typeItemId
			) || null;
		},
		getPaymentStatus(payment){
			console.log('¡getPaymentStatus!', payment)
		},
		toggleShowAnulatedSubcontracts(){
			this.showAnulatedSubcontracts = !this.showAnulatedSubcontracts
			this.userHasChangeAnnulatedSubcontractShow = true
			this.$nextTick(() => {
				this.redrawLeaderLines()
			});
		},
		getAnnnulatedSubcontracts(subcontract){
			//TODO
			return subcontract?.id == 99332
		},
		checkIfSubcontractContract(subcontract){
			return subcontract?.subcontract?.contract?.id || subcontract?.annulated_subcontract?.contract?.id
		},
		getBlockedItemsClass(subcontract){
			return this.subcontractSigned(subcontract) || subcontract?.subcontract?.contract?.last_status?.status == contractStatuses.SUBCONTRATO_ANULADO
		},
		subcontractSigned(subcontract){
			return subcontract?.subcontract?.contract?.last_status?.status == contractStatuses.FIRMADO_AMBAS_PARTES
		},
		openCostBreakdownSummary(info){
			this.$store.commit('costbreakdown/setCostBreakdownSummaryTablesModalInfo', info)
			this.$store.commit('costbreakdown/setCostBreakdownSummaryTablesModal', true)
		},
		getSubcontractsInfoForMainProject(costTableInfo){
			const mainProject = this.summarySubcontractInfo.mainProjects.find(mp => mp.item_id === costTableInfo.item_id)
			const info = mainProject?.project_table?.subcontracts_info
			const finalInfo = {
				...info,
				cost_table: {
					...info.cost_table,
					cost_table_info: mainProject?.project_table
				}
			}
			return finalInfo;
		},
		redrawLeaderLines(){
			if(this.redrawingLines || !this.showTopButtons) return;
			this.redrawingLines = true;
			if(this.lines && this.lines.length > 0){
				this.lines.forEach(line => line.remove());
			}
			this.lines = [];
			this.initLeaderLine();
			this.$nextTick(() => {
				this.redrawingLines = false;
			});
		},
		initLeaderLine(){
			this.$nextTick(() => {
				this.orderedBySubcontract.forEach((subcontractGroup, index) => {
					const parentRef = this.$refs['line_parent'];
					const childRef = this.$refs['line_child' + index];
					const childStartRef = this.$refs['line_child_start' + index];
					const elementsRef = this.$refs['line_element_container' + index];
					
					if(!parentRef || !childRef || !childStartRef || !elementsRef || elementsRef.length === 0){
						return;
					}
					
					const childRefEl = Array.isArray(childRef) ? childRef[0] : childRef;
					const childStartRefEl = Array.isArray(childStartRef) ? childStartRef[0].$el : childStartRef.$el;
					
					if (parentRef && childRefEl) {
						const line = new LeaderLine(
							LeaderLine.pointAnchor(parentRef, { x: 10,   y: '100%' }),
							LeaderLine.pointAnchor(childRefEl,  { x: 0,   y: '10%'  }),
							{
								path: 'grid',
								startSocketGravity: [0, 0],
								endSocketGravity: [-4, 0],
								size: 2,
								startPlug: 'behind',
								endPlug: 'arrow2',
								color: '#999',
								hide: true
							}
						);
						this.lines.push(line);
					}

					// Buscar todos los elementos line_element en el DOM para este subcontrato
					// const elementsRefList = document.querySelectorAll(`[data-line-element-subcontract="${index}"]`);
					elementsRef.forEach((el) => {
						const childFinalElement = el.$refs['line_element' + index];
						const element_line = new LeaderLine(
							LeaderLine.pointAnchor(childStartRefEl, { x: 10,   y: '100%' }),
							LeaderLine.pointAnchor(childFinalElement,  { x: 0,   y: '50%'  }),
							{
								path: 'grid',
								startSocketGravity: [0, 0],
								endSocketGravity: [-4, 0],
								size: 2,
								startPlug: 'behind',
								endPlug: 'arrow2',
								color: '#999',
								hide: true
							}
						);
						this.lines.push(element_line);
					});
				});
				window.addEventListener('scroll', this.updateLeaderLinePosition);
				document.addEventListener('scroll', this.updateLeaderLinePosition, true);
				setTimeout(() => {
					this.updateLeaderLinePosition();
					this.lines.forEach(line => line.show('draw', {duration: 1000}));
				}, 1000);
			});
		},
		updateLeaderLinePosition(){
			if(this.lines && this.lines.length > 0){
				this.lines.forEach(line => line.position());
			}
		},
		subContractor(subcontract){
			if(subcontract.contractor?.profile){
				return subcontract.contractor?.profile?.name + ' ' + subcontract.contractor?.profile?.lastname + ' ' + subcontract.contractor?.profile?.second_lastname	
			}
			return 'Sin Subcontratista'
		},
		getMainProjectDescription(mainProject){
			return mainProject?.project_table?.project_cost_info?.title || ''
		},
		getMainProjectTitle(mainProject){
      const parentName = mainProject?.project_table?.contract?.info?.project_type?.parent?.name || this.project?.info?.project_type?.parent?.name || '';
      const categoryName = mainProject?.project_table?.contract?.info?.project_type?.category?.name || this.project?.info?.project_type?.category?.name || '';
			const projectTypeName = mainProject?.project_table?.contract?.info?.project_type?.name
      
      if (parentName && categoryName) {
        return `${categoryName} | ${parentName} | ${projectTypeName}`;
      }
      return parentName || categoryName || '';
		},
		getProjectCode(contract) {
			if(contract?.parent_contract){
				let append = ''
				if(contract.addendum_to_contract_id){
					append = ` - ANX Nº ${contract.addendum_index}`
				}
				else if(contract.subcontract_to_contract_id){
					append = ` - SUB Nº ${contract.subcontract_index}`
				}
				return `${contract.serial?.serial} - LP${this.project?.project_line_info?.project_line?.number} - ${contract.info?.prefix?.prefix} ${contract.parent_contract?.info?.contract_prefix_index} ${append}`
			}
			return `${contract.serial?.serial} - LP${this.project?.project_line_info?.project_line?.number} - ${contract.info?.prefix?.prefix} ${contract.info?.contract_prefix_index}`
		},
		debugObjectDiff(newObj, oldObj, path = '') {
			const changes = []

			for (const key in newObj) {
				const newPath = path ? `${path}.${key}` : key
				const newVal = newObj[key]
				const oldVal = oldObj ? oldObj[key] : undefined

				if (typeof newVal === 'object' && newVal !== null && !Array.isArray(newVal)) {
					changes.push(...this.debugObjectDiff(newVal, oldVal, newPath))
				} else if (Array.isArray(newVal)) {
					if (JSON.stringify(newVal) !== JSON.stringify(oldVal)) {
						changes.push({ path: newPath, oldValue: oldVal, newValue: newVal })
					}
				} else if (newVal !== oldVal) {
					changes.push({ path: newPath, oldValue: oldVal, newValue: newVal })
				}
			}

			return changes
		},
		validateMaxPercent(costsPayment, item) {
			let currentValue = Number(costsPayment.payment_value_percent) || 0
			
			// Validar que no supere 100%
			if (currentValue > 100) {
				this.debounceSetMessage({
					message: 'Este porcentaje no puede ser mayor a 100%. Por favor ajústalo.',
					title: 'Validación',
					type: 'error',
					icon: 'mdi-alert-circle-outline',
					color: '#FF120B',
				});
				currentValue = 100;
			}
			
			const totalWithoutCurrent = item.payments.reduce((sum, p) => {
				if (p !== costsPayment) {
					sum += Number(p.payment_value_percent) || 0
				}
				return sum
			}, 0)
			const maxAllowed = Math.max(0, 100 - totalWithoutCurrent)
			
			if (currentValue > maxAllowed) {
				this.debounceSetMessage({
					message: `El total de cuotas no puede superar el 100%. El máximo disponible para esta cuota es ${maxAllowed}%.`,
					title: 'Validación',
					type: 'error',
					icon: 'mdi-alert-circle-outline',
					color: '#FF120B',
				});
			}
			
			currentValue = Math.min(currentValue, maxAllowed)
			this.$nextTick(() => {
				this.$set(costsPayment, 'payment_value_percent', currentValue)
			})
		},
		setBaseValues(){
			// console.log('[DEBUG] setBaseValues called, resetting subcontract info arrays and processing summaryInfo');
			this.costTableSubcontractinfo = []
			this.stagesSubcontractinfo = []
			this.specialtiesSubcontractinfo = []
			this.receptionSubcontractinfo = null
			
			// Main Projects - usar summaryInfo.mainProjects (puede ser array con múltiples proyectos)
			if(this.summaryInfo.mainProjects && this.summaryInfo.mainProjects.length > 0){
				this.summaryInfo.mainProjects.forEach(mainProject => {
					const projectTable = mainProject.project_table
					console.log('[DEBUG] Processing projectTable:', projectTable)

					if(projectTable.subcontract){
						// Buscar en projectTable primero; si no, en tabla principal como fallback (carga inicial desde BD)
						const costTableSource =
							projectTable.subcontracts_info?.cost_table
						const annulatedCostTableSource =
							projectTable.annulated_subcontracts_info?.cost_table
							|| this.costsTable.annulated_subcontracts_info?.cost_table
						if(costTableSource || annulatedCostTableSource?.length){
							// Procesar cost_table activo
							const costTable = costTableSource;
							if (costTable) {
								const finalValue = {
									...costTable,
									...{project_table: projectTable},
									_isAnnulatedRecord: false
								}
								this.costTableSubcontractinfo.push(finalValue)
								this.setItemClpValueFromUf(finalValue)
								this.setAdditionalItemClpValueFromUf(finalValue)
							}
							
							// Procesar cost_table anulados (ahora es un array)
							const annulatedCostTables = annulatedCostTableSource;
							if (Array.isArray(annulatedCostTables)) {
								annulatedCostTables.forEach(annulatedCostTable => {
									const finalValue = {
										...annulatedCostTable,
										...{project_table: projectTable},
										_isAnnulatedRecord: true
									}
									this.costTableSubcontractinfo.push(finalValue)
									// No se aplica setItemClpValueFromUf para annulated
								})
							} else if (annulatedCostTables) {
								// Caso de compatibilidad hacia atrás si aún es objeto único
								const finalValue = {
									...annulatedCostTables,
									...{project_table: projectTable},
									_isAnnulatedRecord: true
								}
								this.costTableSubcontractinfo.push(finalValue)
							}
						}
						else {
							this.costTableSubcontractinfo.push({
								item_id: projectTable.id,
								item_type: 'cost_table',
								cost_value_uf: 0,
								cost_value_clp: 0,
								payments: [],
								project_table: projectTable
							})
						}
					}
				})
			}
			console.log('[DEBUG] After processing mainProjects, costTableSubcontractinfo:', this.costTableSubcontractinfo);

			// Stages
			if(this.summaryInfo.stages && this.summaryInfo.stages.filter(s => s.subcontract).length){
				this.stagesSubcontractinfo = this.stagesSubcontractinfo.filter(s => this.summaryInfo.stages.find(stage => stage.id === s.item_id))
				const subContractStages = this.summaryInfo.stages.filter(s => s.subcontract)
				subContractStages.forEach(stage => {
					const projectTable = stage.project_table
					// Buscar en projectTable primero; si no, en tabla principal como fallback (carga inicial desde BD)
					const stagesInfo =
						projectTable.subcontracts_info?.stages?.find(s => s.item_id === stage.id)
						|| this.costsTable.subcontracts_info?.stages?.find(s => s.item_id === stage.id)
					const annulatedStagesInfo =
						projectTable.annulated_subcontracts_info?.stages?.find(s => s.item_id === stage.id)
						|| this.costsTable.annulated_subcontracts_info?.stages?.find(s => s.item_id === stage.id)

					if(stagesInfo){
						const finalValue = {
							...stagesInfo,
							...{stage, project_table: projectTable}
						}
						const index = this.stagesSubcontractinfo.findIndex(s => s.item_id === stage.id)
						if(index === -1){
							this.stagesSubcontractinfo.push(finalValue)
							this.setItemClpValueFromUf(finalValue)
						} else {
							this.$set(this.stagesSubcontractinfo[index], 'stage', stage)
						}
					} else {
						// No encontrado en ninguna fuente, crear default
						const toSaveInfo = {
							item_id: stage.id,
							item_type: 'stage',
							cost_value_uf: 0,
							cost_value_clp: 0,
							stage: stage,
							payments: [],
							project_table: projectTable
						}
						const index = this.stagesSubcontractinfo.findIndex(s => s.item_id === stage.id)
						if(index === -1){
							this.stagesSubcontractinfo.push(toSaveInfo)
						} else {
							this.$set(this.stagesSubcontractinfo[index], 'stage', stage)
						}
					}

					if(annulatedStagesInfo){
						const finalValue = {
							...annulatedStagesInfo,
							...{stage, project_table: projectTable}
						}
						const index = this.stagesSubcontractinfo.findIndex(s => s.item_id === stage.id && s.annulated)
						if(index === -1){
							this.stagesSubcontractinfo.push(finalValue)
							// sin setItemClpValueFromUf para annulated
						}
					}
				})
			}
			
			// Specialties
			if(this.summaryInfo.specialties && this.summaryInfo.specialties.filter(s => s.subcontract).length){
				this.specialtiesSubcontractinfo = this.specialtiesSubcontractinfo.filter(s => this.summaryInfo.specialties.find(specialty => specialty.id === s.item_id))
				const subContractSpecialties = this.summaryInfo.specialties.filter(s => s.subcontract)
				subContractSpecialties.forEach(specialty => {
					const projectTable = specialty.project_table
					// Buscar en projectTable primero; si no, en la tabla principal como fallback (carga inicial desde BD)
					const specialtiesInfo =
						projectTable.subcontracts_info?.specialties?.find(s => s.item_id === specialty.id)
						|| this.costsTable.subcontracts_info?.specialties?.find(s => s.item_id === specialty.id)
					const annulatedSpecialtiesInfo =
						projectTable.annulated_subcontracts_info?.specialties?.find(s => s.item_id === specialty.id)
						|| this.costsTable.annulated_subcontracts_info?.specialties?.find(s => s.item_id === specialty.id)

					if(specialtiesInfo){
						const finalValue = {
							...specialtiesInfo,
							...{specialty, project_table: projectTable}
						}
						const index = this.specialtiesSubcontractinfo.findIndex(s => s.item_id === specialty.id)
						if(index === -1){
							this.specialtiesSubcontractinfo.push(finalValue)
							this.setItemClpValueFromUf(finalValue)
						} else {
							this.$set(this.specialtiesSubcontractinfo[index], 'specialty', specialty)
						}
					} else {
						// No encontrado en ninguna fuente, crear default
						const toSaveInfo = {
							item_id: specialty.id,
							item_type: 'specialty',
							cost_value_uf: 0,
							cost_value_clp: 0,
							specialty: specialty,
							payments: [],
							project_table: projectTable
						}
						const index = this.specialtiesSubcontractinfo.findIndex(s => s.item_id === specialty.id)
						if(index === -1){
							this.specialtiesSubcontractinfo.push(toSaveInfo)
						} else {
							this.$set(this.specialtiesSubcontractinfo[index], 'specialty', specialty)
						}
					}

					if(annulatedSpecialtiesInfo){
						const finalValue = {
							...annulatedSpecialtiesInfo,
							...{specialty, project_table: projectTable}
						}
						const index = this.specialtiesSubcontractinfo.findIndex(s => s.item_id === specialty.id && s.annulated)
						if(index === -1){
							this.specialtiesSubcontractinfo.push(finalValue)
						}
					}
				})
			}
			
			// Reception - usar summaryInfo.reception
			if(this.summaryInfo?.reception?.subcontract){
				const projectTable = this.summaryInfo.reception.project_table
				// Buscar en projectTable primero; si no, en tabla principal como fallback (carga inicial desde BD)
				const receptionSource =
					projectTable.subcontracts_info?.reception
					|| this.costsTable.subcontracts_info?.reception
				const annulatedReceptionSource =
					projectTable.annulated_subcontracts_info?.reception
					|| this.costsTable.annulated_subcontracts_info?.reception
				if(receptionSource || annulatedReceptionSource){
					if(receptionSource){
						const reception = receptionSource
						this.receptionSubcontractinfo = {
							...reception,
							...{project_table: projectTable}
						}
						this.setItemClpValueFromUf(this.receptionSubcontractinfo)
					}
					// Procesar reception anulada (ahora es un array) - solo si no hay activa
					else if (annulatedReceptionSource) {
						const annulatedReceptions = annulatedReceptionSource;
						if (Array.isArray(annulatedReceptions)) {
							if (annulatedReceptions.length === 0) {
								// Array vacío, asignar reception default
								this.receptionSubcontractinfo = {
									item_id: this.summaryInfo.reception.id,
									item_type: 'reception',
									cost_value_uf: 0,
									cost_value_clp: 0,
									payments: [],
									annulated: true,
									project_table: projectTable
								}
							} else {
								annulatedReceptions.forEach(annulatedReception => {
									this.receptionSubcontractinfo = {
										...annulatedReception,
										item_id: annulatedReception.id || annulatedReception.item_id,
										item_type: 'reception',
										...{project_table: projectTable}
									}
									// sin setItemClpValueFromUf para annulated
								})
							}
						} else {
							// Caso de compatibilidad hacia atrás si aún es objeto único
							this.receptionSubcontractinfo = {
								...annulatedReceptions,
								item_id: annulatedReceptions.id || annulatedReceptions.item_id,
								item_type: 'reception',
								...{project_table: projectTable}
							}
							// sin setItemClpValueFromUf para annulated
						}
					}
				}
				// Fallback: Si no hay subcontratos especializados, asignar la recepción principal
				else if (!this.receptionSubcontractinfo) {
					this.receptionSubcontractinfo = {
						...this.summaryInfo.reception,
						item_id: this.summaryInfo.reception.id,
						item_type: 'reception',
						...{project_table: projectTable}
					}
					this.setItemClpValueFromUf(this.receptionSubcontractinfo)
				}
				else if(!this.receptionSubcontractinfo){
					this.receptionSubcontractinfo = {
						item_id: this.summaryInfo.reception.id,
						item_type: 'reception',
						cost_value_uf: 0,
						cost_value_clp: 0,
						payments: [],
						project_table: projectTable
					}
				}
			}
			else{
				this.receptionSubcontractinfo = null
			}
			this.redrawLeaderLines();
			if (!this.updatingFromParent) {
				this.debounceUpdateModelItem()
			}
		},
		onKeyPress(event){
			if(event.target?.value > 9999999){
				event.preventDefault();
			}
		},
		validateCLP(e) {
			if (e.key === 'e') {
				e.preventDefault()
			}
			if(e.target?.value > 9999999999){
				e.preventDefault();
			}
		},
		sanitizeUF(item, contractValues = null) {
			let value = String(item.cost_value_uf ?? '');
			value = value.replace(',', '.');
			if(contractValues && parseFloat(value) > contractValues.total_cost_uf){
				this.$set(item, 'cost_value_uf', '');
				this.$nextTick(() => {
					this.$set(item, 'cost_value_uf', contractValues.total_cost_uf.toString());
					this.setItemClpValueFromUf(item)
				});
				return;
			}
			const isNegative = value.startsWith('-');
			value = value
				.replace(/[^0-9.]/g, '')
				.replace(/^0+(?=\d)/, '');
			const parts = value.split('.');
			if (parts.length > 2) {
				value = parts[0] + '.' + parts.slice(1).join('');
			}
			if (isNegative && value !== '') {
				value = '-' + value;
			}
			item = {
				...item,
				cost_value_uf: value
			};
			if (value !== '' && !value.endsWith('.')) {
				this.setItemClpValueFromUf(item)
			}
		},
		sanitizeIntegerInput(item, contractValues = null) {
			let value = item.cost_value_clp
			if(contractValues && value > contractValues.total_cost_clp){
				this.$set(item, 'cost_value_clp', '');
				this.$nextTick(() => {
					this.$set(item, 'cost_value_clp', contractValues.total_cost_clp.toString());
					this.setItemUfValueFromClp(item)
				});
				return;
			}
			item = {
				...item,
				cost_value_clp: value
					.replace(/\D/g, '')
					.replace(/^0+(?!$)/, '') || 0
			}
			this.setItemUfValueFromClp(item)
		},
		setItemClpValueFromUf(item){
			const ufValue = item.subcontract?.contract?.info?.uf_value?.uf_value|| item.project_table?.uf_value?.uf_value || this.ufValue
			const clp_value = item.cost_value_uf * ufValue
			item.cost_value_clp = parseFloat(clp_value)
			item.from_change = 'uf'
			this.updateModelItem(item)
		},
		setItemUfValueFromClp(item){
			const ufValue = item.project_table?.uf_value?.uf_value || this.ufValue
			const uf_value = item.cost_value_clp / ufValue
			item = {...item, ...{cost_value_uf: parseFloat(uf_value), from_change: 'clp'}}
			this.updateModelItem(item)
		},
		sanitizeAdditionalUF(item, contractValues = null) {
			let value = item.additional_cost_value_uf;
			if(contractValues && value > contractValues.total_cost_uf){
				this.$set(item, 'additional_cost_value_uf', '');
				this.$nextTick(() => {
					this.$set(item, 'additional_cost_value_uf', contractValues.total_cost_uf.toString());
					this.setAdditionalItemClpValueFromUf(item)
				});
				return;
			}
			const isNegative = value.startsWith('-');
			value = value
				.replace(/[^0-9.]/g, '')
				.replace(/^0+(?=\d)/, '');
			const parts = value.split('.');
			if (parts.length > 2) {
				value = parts[0] + '.' + parts.slice(1).join('');
			}
			if (isNegative && value !== '') {
				value = '-' + value;
			}
			item = {
				...item,
				additional_cost_value_uf: value || '0'
			};
			this.setAdditionalItemClpValueFromUf(item)
		},
		sanitizeIntegerAdditionalInput(item, contractValues = null) {
			let value = item.additional_cost_value_clp
			if(contractValues && value > contractValues.total_cost_clp){
				this.$set(item, 'additional_cost_value_clp', '');
				this.$nextTick(() => {
					this.$set(item, 'additional_cost_value_clp', contractValues.total_cost_clp.toString());
					this.setAdditionalItemUfValueFromClp(item)
				});
				return;
			}
			item = {
				...item,
				additional_cost_value_clp: value
					.replace(/\D/g, '')
					.replace(/^0+(?!$)/, '') || 0
			}
			this.setAdditionalItemUfValueFromClp(item)
		},
		setAdditionalItemClpValueFromUf(item){
			const clp_value = item.additional_cost_value_uf * this.ufValue
			item.additional_cost_value_clp = parseFloat(clp_value)
			item.from_change = 'uf'
			this.updateModelItem(item)
		},
		setAdditionalItemUfValueFromClp(item){
			const uf_value = item.additional_cost_value_clp / this.ufValue
			item = {...item, ...{additional_cost_value_uf: parseFloat(uf_value), from_change: 'clp'}}
			this.updateModelItem(item)
		},
		addPaymentToItem(item){
			// Validar que la sección no tenga ya 100%
			const currentPercent = this.getAllPaymentPercentValues(item);
			
			if (currentPercent >= 100) {
				this.debounceSetMessage({
					message: 'Esta sección ya tiene asignado el 100% de las cuotas. No se pueden agregar más cuotas.',
					title: 'Validación',
					type: 'error',
					icon: 'mdi-alert-circle-outline',
					color: '#FF120B',
				});
				return;
			}

			const payments = item.payments || []
			payments.push({
				name: '',
				payment_value_percent: 0,
				payment_schedule_date: null
			})
			item = {...item, ...{payments}}
			this.updateModelItem(item)
		},
		debounceUpdateModelItem: _debounce(function(){ this.emitChange() }, 200),
		emitChange(){
			const updatedTables = {}
			
			this.summarySubcontractInfo.mainProjects?.forEach(mainProject => {
				if (!mainProject?.project_table?.id) return
				const projectTableId = mainProject.project_table.id
				if (!updatedTables[projectTableId]) {
					updatedTables[projectTableId] = {
						project_table: mainProject.project_table,
						subcontracts_info: {
							cost_table: null,
							stages: [],
							specialties: [],
							reception: null
						},
						annulated_subcontracts_info: {
						cost_table: [],
						stages: [],
						specialties: [],
						reception: []
					}
				}
			}
			const costTableInfo = this.costTableSubcontractinfo.find(ct => ct.item_id === mainProject.item_id && !ct.deleted_at && !ct.annulated_subcontract)
			const anulatedCostTableInfoArray = this.costTableSubcontractinfo.filter(ct => ct.item_id === mainProject.item_id && !ct.deleted_at && ct.annulated_subcontract)
			
			if (costTableInfo) {
				updatedTables[projectTableId].subcontracts_info.cost_table = costTableInfo
			}
			
			if (anulatedCostTableInfoArray && anulatedCostTableInfoArray.length > 0) {
				updatedTables[projectTableId].annulated_subcontracts_info.cost_table = anulatedCostTableInfoArray
			}
		})
		
		this.summarySubcontractInfo.stages?.forEach(stage => {
			if (!stage?.project_table?.id) return
			const projectTableId = stage.project_table.id
			if (!updatedTables[projectTableId]) {
				updatedTables[projectTableId] = {
					project_table: stage.project_table,
					subcontracts_info: {
						cost_table: null,
						stages: [],
						specialties: [],
						reception: null
					},
					annulated_subcontracts_info: {
						cost_table: [],
						stages: [],
						specialties: [],
						reception: []
					}
				}
			}
			const stageInfo = this.stagesSubcontractinfo.find(s => s.item_id === stage.item_id && !s.deleted_at && !s.annulated_subcontract)
			const anulatedStageInfo = this.stagesSubcontractinfo.find(s => s.item_id === stage.item_id && !s.deleted_at && s.annulated_subcontract)
			if (stageInfo) {
				updatedTables[projectTableId].subcontracts_info.stages.push(stageInfo)
			}
			if (anulatedStageInfo) {
				updatedTables[projectTableId].annulated_subcontracts_info.stages.push(anulatedStageInfo)
			}
		})
		
		this.summarySubcontractInfo.specialties?.forEach(specialty => {
			if (!specialty?.project_table?.id) return
			const projectTableId = specialty.project_table.id
			if (!updatedTables[projectTableId]) {
				updatedTables[projectTableId] = {
					project_table: specialty.project_table,
					subcontracts_info: {
						cost_table: null,
						stages: [],
						specialties: [],
						reception: null
					},
					annulated_subcontracts_info: {
						cost_table: [],
						stages: [],
						specialties: [],
						reception: []
					}
				}
			}
			const specialtyInfo = this.specialtiesSubcontractinfo.find(sp => sp.item_id === specialty.item_id && !sp.deleted_at && !sp.annulated_subcontract)
			const anulatedSpecialtyInfo = this.specialtiesSubcontractinfo.find(sp => sp.item_id === specialty.item_id && !sp.deleted_at && sp.annulated_subcontract)
			if (specialtyInfo) {
				updatedTables[projectTableId].subcontracts_info.specialties.push(specialtyInfo)
			}
			if (anulatedSpecialtyInfo) {
				updatedTables[projectTableId].annulated_subcontracts_info.specialties.push(anulatedSpecialtyInfo)
			}
		})
		
		if (this.summarySubcontractInfo.reception?.project_table?.id) {
				const projectTableId = this.summarySubcontractInfo.reception.project_table.id
				if (!updatedTables[projectTableId]) {
					updatedTables[projectTableId] = {
						project_table: this.summarySubcontractInfo.reception.project_table,
						subcontracts_info: {
							cost_table: null,
							stages: [],
							specialties: [],
							reception: null
						},
						annulated_subcontracts_info: {
							cost_table: [],
							stages: [],
							specialties: [],
							reception: []
						}
					}
				}
				
				// Filtrar reception activa y annulated por separado
				const receptionInfo = this.receptionSubcontractinfo && !this.receptionSubcontractinfo.deleted_at && !this.receptionSubcontractinfo.annulated_subcontract
					? this.receptionSubcontractinfo
					: null
				const annulatedReceptionInfo = this.receptionSubcontractinfo && !this.receptionSubcontractinfo.deleted_at && this.receptionSubcontractinfo.annulated_subcontract
					? [this.receptionSubcontractinfo]
					: []
				if (receptionInfo) {
					updatedTables[projectTableId].subcontracts_info.reception = receptionInfo
				}
				if (annulatedReceptionInfo && annulatedReceptionInfo.length > 0) {
					updatedTables[projectTableId].annulated_subcontracts_info.reception = annulatedReceptionInfo
				}
			}
			
			// Pase final: recuperar TODOS los annulated que no hayan sido procesados
			// Para costTable
			this.costTableSubcontractinfo.forEach(costTable => {
				if (!costTable || costTable.deleted_at) return
				if (!costTable.annulated_subcontract) return // Solo los annulated
				const projectTableId = costTable.project_table?.id
				if (!projectTableId) return
				
				if (!updatedTables[projectTableId]) {
					updatedTables[projectTableId] = {
						project_table: costTable.project_table,
						subcontracts_info: {
							cost_table: null,
							stages: [],
							specialties: [],
							reception: null
						},
						annulated_subcontracts_info: {
							cost_table: [],
							stages: [],
							specialties: [],
							reception: []
						}
					}
				}
				
				// Verificar que no esté duplicado
				const alreadyExists = updatedTables[projectTableId].annulated_subcontracts_info.cost_table.some(ct => ct.item_id === costTable.item_id)
				if (!alreadyExists && Array.isArray(updatedTables[projectTableId].annulated_subcontracts_info.cost_table)) {
					updatedTables[projectTableId].annulated_subcontracts_info.cost_table.push(costTable)
				}
			})
			
			// Para stages
			this.stagesSubcontractinfo.forEach(stage => {
				if (!stage || stage.deleted_at) return
				if (!stage.annulated_subcontract) return // Solo los annulated
				const projectTableId = stage.project_table?.id
				if (!projectTableId) return
				
				if (!updatedTables[projectTableId]) {
					updatedTables[projectTableId] = {
						project_table: stage.project_table,
						subcontracts_info: {
							cost_table: null,
							stages: [],
							specialties: [],
							reception: null
						},
						annulated_subcontracts_info: {
							cost_table: [],
							stages: [],
							specialties: [],
							reception: []
						}
					}
				}
				
				// Verificar que no esté duplicado
				const alreadyExists = updatedTables[projectTableId].annulated_subcontracts_info.stages.some(s => s.item_id === stage.item_id)
				if (!alreadyExists && Array.isArray(updatedTables[projectTableId].annulated_subcontracts_info.stages)) {
					updatedTables[projectTableId].annulated_subcontracts_info.stages.push(stage)
				}
			})
			
			// Para specialties
			this.specialtiesSubcontractinfo.forEach(specialty => {
				if (!specialty || specialty.deleted_at) return
				if (!specialty.annulated_subcontract) return // Solo los annulated
				const projectTableId = specialty.project_table?.id
				if (!projectTableId) return
				
				if (!updatedTables[projectTableId]) {
					updatedTables[projectTableId] = {
						project_table: specialty.project_table,
						subcontracts_info: {
							cost_table: null,
							stages: [],
							specialties: [],
							reception: null
						},
						annulated_subcontracts_info: {
							cost_table: [],
							stages: [],
							specialties: [],
							reception: []
						}
					}
				}
				
				// Verificar que no esté duplicado
				const alreadyExists = updatedTables[projectTableId].annulated_subcontracts_info.specialties.some(sp => sp.item_id === specialty.item_id)
				if (!alreadyExists && Array.isArray(updatedTables[projectTableId].annulated_subcontracts_info.specialties)) {
					updatedTables[projectTableId].annulated_subcontracts_info.specialties.push(specialty)
				}
			})
			
			if(this.saveSelf){
				this.startSaveEvent()
			}

			// Limpiar project_table de los ítems antes de emitir al padre.
			// project_table es una referencia al propio costsTable (objeto del store), lo que
			// causaría que Vuex almacene el costsTable dentro de sí mismo (referencia circular/anidada),
			// disparando el watcher en loop aunque deepDiff devuelva [].
			const stripProjectTable = (obj) => {
				if (!obj || typeof obj !== 'object') return obj;
				const { project_table, ...rest } = obj; // eslint-disable-line no-unused-vars
				return rest;
			};
			const strippedTables = {};
			Object.entries(updatedTables).forEach(([id, tableData]) => {
				strippedTables[id] = {
					subcontracts_info: {
						cost_table: stripProjectTable(tableData.subcontracts_info.cost_table),
						stages: (tableData.subcontracts_info.stages || []).map(stripProjectTable),
						specialties: (tableData.subcontracts_info.specialties || []).map(stripProjectTable),
						reception: stripProjectTable(tableData.subcontracts_info.reception)
					},
					annulated_subcontracts_info: {
						cost_table: (tableData.annulated_subcontracts_info.cost_table || []).map(stripProjectTable),
						stages: (tableData.annulated_subcontracts_info.stages || []).map(stripProjectTable),
						specialties: (tableData.annulated_subcontracts_info.specialties || []).map(stripProjectTable),
						reception: (tableData.annulated_subcontracts_info.reception || []).map(stripProjectTable)
					}
				};
			});

			// Deduplicar: no emitir si el contenido no cambió respecto a la última emisión.
			// Previene el ping-pong entre las dos instancias montadas en CostBreakdownTable.
			const emitKey = JSON.stringify(strippedTables);
			if (emitKey === this.lastEmitKey) return;
			this.lastEmitKey = emitKey;

			console.log('[Debug] Emitting updated subcontract info:', strippedTables)
			this.$emit('update:subcontractInfo', strippedTables)
			this.updateLeaderLinePosition()
		},
		handleUpdateContractor(item){
			item.subcontract = null
			this.updateModelItem(item)
		},
		handleUpdateSubcontractor(item){
			this.updateModelItem(item)
		},
		updateModelItem(item){
			item.deleted_at = null
			if(item.item_type == 'cost_table'){
				const costTableIndex = this.costTableSubcontractinfo.findIndex(ct => ct.item_id == item.item_id && !ct.deleted_at && !ct.annulated_subcontract)
				if(costTableIndex != -1){
					this.$set(this.costTableSubcontractinfo, costTableIndex, item)
				} else {
					this.costTableSubcontractinfo.push(item)
					console.log('[Debug] Agregando nueva cost_table al subcontractinfo:', this.costTableSubcontractinfo)
				}
			}
			if(item.item_type == 'reception'){
				this.receptionSubcontractinfo = item
			}
			if(item.item_type == 'stage'){
				const stageIndex = this.stagesSubcontractinfo.findIndex(stage => stage.item_id == item.item_id)
				if(stageIndex != -1){
					this.$set(this.stagesSubcontractinfo, stageIndex, item)
				}
			}
			if(item.item_type == 'specialty'){
				const specialtyIndex = this.specialtiesSubcontractinfo.findIndex(specialty => specialty.item_id == item.item_id)
				if(specialtyIndex != -1){
					this.$set(this.specialtiesSubcontractinfo, specialtyIndex, item)
				}
			}
			this.debounceUpdateModelItem()
		},
		closeModalAcceptRejectModal(data){
			if(data){
				this.editProjectPlanning()
			}
			this.acceptRejectModalData = null
			this.acceptRejectModal = false
		},
		checkIfCostsPayments(){
			if(!this.costsTable.payments || !this.costsTable.payments.length){
				this.acceptRejectModalData = {
					title: 'Proyecto sin Programación',
					content_a: 'El proyecto no tiene programación asignada. Por favor antes de continuar, asigne la programación del proyecto.',
					content_b: '¿Desea continuar con el proceso de configuración de pagos de la programación del proyecto?',
				}
				this.acceptRejectModal = true
			}
		},
		getAllPaymentPercentValues(paymentProjectType, typeItemId, subcontractId) {
			let total = 0
			this.costsPayments.forEach(costsPayment => {
				const pv = this.getPaymentValue(costsPayment, paymentProjectType, typeItemId, subcontractId)
				if(pv){
					total += pv.amount
				}
			});
			return total

			// return item.payments.reduce((total, payment) => {
			// 	return total + (Number(payment.payment_value_percent) || 0)
			// }, 0)
		},
		startConfigSubpayments(costsPayment, paymentProjectType = 'cost_table', typeItemId, subcontractId){
			const currentPercentForType = this.getAllPaymentPercentValues(paymentProjectType, typeItemId, subcontractId);
			
			if (currentPercentForType >= 100) {
				this.debounceSetMessage({
					message: 'Esta sección ya tiene asignado el 100% de las cuotas. No se pueden agregar más cuotas.',
					title: 'Validación',
					type: 'error',
					icon: 'mdi-alert-circle-outline',
					color: '#FF120B',
				});
				return;
			}

			const index = this.costsTable.payments.findIndex(cp => cp.id === costsPayment.id);
			if (!Array.isArray(costsPayment.subcontract_payments)) {
				costsPayment.subcontract_payments = [];
			}
			let payment = costsPayment.subcontract_payments.find(p =>
				p.item_type === paymentProjectType &&
				p.type_item_id === typeItemId &&
				p.subcontract_id === subcontractId
			);
			if (!payment) {
				payment = {
					item_type: paymentProjectType,
					type_item_id: typeItemId,
					subcontract_id: subcontractId,
					amount: 0,
					subpayments: []
				};
				if (typeItemId !== null) {
					payment.type_item_id = typeItemId;
				}
				costsPayment.subcontract_payments.push(payment);
			}
			if (!Array.isArray(payment.subpayments)) {
				payment.subpayments = [];
			}
			const newSubpaymentIndex = payment.subpayments.length;
			const epIndex = index + 1;
			const newSubpayment = {
				amount: 0,
				id: 'sub_' + Date.now(),
				title: `Cuota ${newSubpaymentIndex + 1} - EP ${epIndex}`
			};
			payment.subpayments.push(newSubpayment);
			payment.amount = payment.subpayments.reduce((sum, sub) => sum + (parseFloat(sub.amount) || 0), 0);
			this.$set(costsPayment, 'total_amount', this.getTotalAmount(costsPayment));
			this.$set(this.costsTable.payments, index, costsPayment);
			this.redrawLeaderLines();
			
			if(this.saveSelf){
				this.startSaveEvent()
			}
		},
		updateSubpaymentValue(costsPayment, index, val, paymentProjectType = 'cost_table', typeItemId, subcontractId) {
			const costsPaymentIndex = this.costsTable.payments.findIndex(cp => cp.id === costsPayment.id);
			// Usar el objeto ORIGINAL del store, no el del computed costsPayments (que tiene propiedades
			// derivadas como subcontract_stage_title que no deben persistirse en el store).
			const originalPayment = this.costsTable.payments[costsPaymentIndex];
			if (!originalPayment) return;
			if (!Array.isArray(originalPayment.subcontract_payments)) {
				originalPayment.subcontract_payments = [];
			}
			let payment = originalPayment.subcontract_payments.find(p =>
				p.item_type === paymentProjectType &&
				p.type_item_id === typeItemId &&
				p.subcontract_id === subcontractId
			);
			if (payment && payment.subpayments && payment.subpayments[index]) {
				let newVal = parseFloat(val) || 0;
				
				const currentSubtotal = payment.subpayments.reduce((sum, sub, i) => {
					return i !== index ? sum + (parseFloat(sub.amount) || 0) : sum;
				}, 0);
				
				const otherPaymentsPercent = this.costsPayments.reduce((total, cp) => {
					if (cp.id === costsPayment.id) return total;
					if (!Array.isArray(cp.subcontract_payments)) return total;
					
					const matchingPayments = cp.subcontract_payments.filter(p =>
						p.item_type === paymentProjectType &&
						p.type_item_id === typeItemId &&
						p.subcontract_id === subcontractId
					);
					return total + matchingPayments.reduce((sum, p) => sum + (parseFloat(p.amount) || 0), 0);
				}, 0);
				
				const maxAllowed = Math.max(0, 100 - currentSubtotal - otherPaymentsPercent);
				
				if (newVal > maxAllowed) {
					this.debounceSetMessage({
						message: `El total de cuotas no puede superar el 100%. Se ha ajustado al máximo disponible de ${maxAllowed}%.`,
						title: 'Validación',
						type: 'warning',
						icon: 'mdi-alert-circle-outline',
						color: '#FF9800',
					});
					newVal = maxAllowed;
				}
				
				this.$set(payment.subpayments[index], 'amount', newVal);
				payment.amount = payment.subpayments.reduce((sum, sub) => sum + (parseFloat(sub.amount) || 0), 0);
				this.$set(originalPayment, 'total_amount', this.getTotalAmount(originalPayment));
				this.$set(this.costsTable.payments, costsPaymentIndex, originalPayment);
			
				if(this.saveSelf){
					this.startSaveEvent()
				}
			}
		},
		updateSubpaymentTitle(costsPayment, index, val, paymentProjectType = 'cost_table', typeItemId, subcontractId) {
			const costsPaymentIndex = this.costsTable.payments.findIndex(cp => cp.id === costsPayment.id);
			const originalPayment = this.costsTable.payments[costsPaymentIndex];
			if (!originalPayment) return;
			if (!Array.isArray(originalPayment.subcontract_payments)) {
				originalPayment.subcontract_payments = [];
			}
			let payment = originalPayment.subcontract_payments.find(p =>
				p.item_type === paymentProjectType &&
				p.type_item_id === typeItemId &&
				p.subcontract_id === subcontractId
			);
			if (payment && payment.subpayments && payment.subpayments[index]) {
				this.$set(payment.subpayments[index], 'title', val);
				this.$set(this.costsTable.payments, costsPaymentIndex, originalPayment);
			
				if(this.saveSelf){
					this.startSaveEvent()
				}
			}
		},
		removeSubpayment(costsPayment, index, paymentProjectType = 'cost_table', typeItemId, subcontractId) {
			const costsPaymentIndex = this.costsTable.payments.findIndex(cp => cp.id === costsPayment.id);
			const originalPayment = this.costsTable.payments[costsPaymentIndex];
			if (!originalPayment) return;
			if (!Array.isArray(originalPayment.subcontract_payments)) {
				originalPayment.subcontract_payments = [];
			}
			let payment = originalPayment.subcontract_payments.find(p =>
				p.item_type === paymentProjectType &&
				p.type_item_id === typeItemId &&
				p.subcontract_id === subcontractId
			);
			if (payment && payment.subpayments && payment.subpayments[index]) {
				payment.subpayments.splice(index, 1);
				payment.amount = payment.subpayments.reduce((sum, sub) => sum + (parseFloat(sub.amount) || 0), 0);
				this.$set(originalPayment, 'total_amount', this.getTotalAmount(originalPayment));
				this.$set(this.costsTable.payments, costsPaymentIndex, originalPayment);
			}
			this.redrawLeaderLines();
			
			if(this.saveSelf){
				this.startSaveEvent()
			}
		},
		startManualPayment(costsPayment, paymentProjectType = 'cost_table', typeItemId, subcontractId){
			console.log('startManualPayment', {costsPayment, paymentProjectType, typeItemId, subcontractId})
		},
		getPaymentValue(costsPayment, paymentProjectType, typeItemId, subcontractId) {
			if (!costsPayment || !Array.isArray(costsPayment.subcontract_payments)) return null;
			return costsPayment.subcontract_payments.find(p =>
				p.item_type === paymentProjectType &&
				p.type_item_id === typeItemId &&
				p.subcontract_id === subcontractId
			) || null;
		},
		getItemPaymentValue(costsPayment, paymentProjectType, typeItemId) {
			if (!costsPayment || !Array.isArray(costsPayment.payments)) return null;
			return costsPayment.payments.find(p =>
				p.item_type === paymentProjectType &&
				p.type_item_id === typeItemId &&
				p.amount > 0
			) || null;
		},
		hasAnyPaymentConfiguredForItem(paymentProjectType, typeItemId) {
			if (!Array.isArray(this.costsPayments)) return false;
			return this.costsPayments.some(costsPayment =>
				this.getItemPaymentValue(costsPayment, paymentProjectType, typeItemId)
			);
		},
		getTotalAmount(costsPayment) {
			let total = 0;
			if (Array.isArray(costsPayment.subcontract_payments)) {
				total += costsPayment.subcontract_payments.reduce((sum, p) => sum + (parseFloat(p.amount) || 0), 0);
			}
			return total;
		},
		getCalculatedSubpayments(payment, costValue, taxRate, itemType, itemId, subcontractId, currentPaymentIndex) {
			if (!payment || !payment.subpayments || !Array.isArray(payment.subpayments)) {
				return [];
			}
			const calculatedPayments = payment.subpayments.map(subpayment => ({
				...subpayment,
				calculatedUf: this.getValueWithTax(costValue.uf, taxRate) * subpayment.amount / 100,
				calculatedClp: this.getValueWithTax(costValue.clp, taxRate) * subpayment.amount / 100
			}));
			const expectedTotalClp = this.getValueWithTax(costValue.clp, taxRate);
			const expectedTotalUf = this.getValueWithTax(costValue.uf, taxRate);
			const isLastPayment = currentPaymentIndex === this.costsPayments.length - 1;
			if (isLastPayment) {
				let totalSumClp = 0;
				let totalSumUf = 0;
				this.costsPayments.forEach((payment) => {
					const pData = this.getPaymentValue(payment, itemType, itemId, subcontractId);
					if (pData && pData.subpayments) {
						pData.subpayments.forEach(sp => {
							totalSumClp += this.getValueWithTax(costValue.clp, taxRate) * sp.amount / 100;
							totalSumUf += parseFloat((this.getValueWithTax(costValue.uf, taxRate) * sp.amount / 100).toFixed(2));
						});
					}
				});
				const differenceClp = Math.round(expectedTotalClp) - totalSumClp;
				const differenceUf = expectedTotalUf - totalSumUf;
				if (calculatedPayments.length > 0 && Math.abs(differenceClp) > 0.01 && Math.abs(differenceClp) <= 1) {
					calculatedPayments[calculatedPayments.length - 1].calculatedClp += differenceClp;
					calculatedPayments[calculatedPayments.length - 1].calculatedUf += differenceUf;
				}
			}

			return calculatedPayments;
		},
		getPaymentSubtotalWithAdjustment(payment, costValue, taxRate, itemType, itemId, subcontractId, currentPaymentIndex) {
			const calculatedSubpayments = this.getCalculatedSubpayments(payment, costValue, taxRate, itemType, itemId, subcontractId, currentPaymentIndex);
			if (!calculatedSubpayments || calculatedSubpayments.length === 0) {
				return { uf: 0, clp: 0 };
			}
			
			const subtotal = calculatedSubpayments.reduce((acc, subpayment) => ({
				uf: acc.uf + subpayment.calculatedUf,
				clp: acc.clp + subpayment.calculatedClp
			}), { uf: 0, clp: 0 });
			
			return subtotal;
		},
		calculateNewPaymentPercent(paymentProjectType, newValue, costPayment, typeItemId = null) {
			if (!Array.isArray(this.costsPayments)) return 0;

			let currentTotal = 0;

			this.costsPayments.forEach(cp => {
				if (!Array.isArray(cp.payments)) return;

				cp.payments.forEach(p => {
					const matchesType = p.item_type === paymentProjectType;
					const matchesItemId = typeItemId === null || p.type_item_id === typeItemId;

					if (matchesType && matchesItemId) {
						// Omitimos el item que vamos a actualizar
						if (cp !== costPayment) {
							const amount = parseFloat(p.amount);
							currentTotal += isNaN(amount) ? 0 : amount;
						}
					}
				});
			});

			const proposedTotal = currentTotal + parseFloat(newValue || 0);
			return proposedTotal;
		},
		debounceUpdatePaymentValue: debounce(function(costPayment, paymentProjectType, newValue, typeItemId = null) {
			this.updatePaymentValue(costPayment, paymentProjectType, newValue, typeItemId);
		}, 300),
		preUpdateVaue(costPayment, paymentProjectType, newValue, typeItemId = null){
			const ref = paymentProjectType + '_' + costPayment.id
			const component = this.$refs[ref][0]
			const prevValue = component.value
			const inputEl = component.$el.querySelector('input')

			if(newValue > 100){
				this.debounceSetMessage({
					message: 'Este porcentaje no puede ser mayor a 100%. Por favor ajústalo.',
					title: 'Validación',
					type: 'error',
					icon: 'mdi-alert-circle-outline',
					color: '#FF120B',
				})
				setTimeout(() => {
					inputEl.value = prevValue
				}, 10)
				return;
			}
			this.debounceUpdatePaymentValue(costPayment, paymentProjectType, newValue, typeItemId)
		},
		updatePaymentValue(costPayment, paymentProjectType, newValue, typeItemId = null) {
			const proposedPercent = this.calculateNewPaymentPercent(paymentProjectType, newValue, costPayment, typeItemId);
			if (proposedPercent > 100) {
				const ref = paymentProjectType + '_' + costPayment.id
				const component = this.$refs[ref][0]
				const inputEl = component.$el.querySelector('input')
				inputEl.value = 100 - (proposedPercent-newValue)
				newValue = 100 - (proposedPercent-newValue)
				this.debounceSetMessage({
					message: 'El porcentaje de este elemento supera el 100%. Se ha ajustado al máximo disponible.',
					title: 'Validación',
					type: 'error',
					icon: 'mdi-alert-circle-outline',
					color: '#FF120B',
				})
			}
			if (!Array.isArray(costPayment.payments)) {
				this.$set(costPayment, 'payments', []);
			}
			let payment = costPayment.payments.find(p =>
				p.item_type === paymentProjectType &&
				(typeItemId === null || p.type_item_id === typeItemId)
			);

			if (payment) {
				payment.amount = newValue;
			} else {
				const newPayment = {
					item_type: paymentProjectType,
					amount: newValue
				};
				if (typeItemId !== null) {
					newPayment.type_item_id = typeItemId;
				}
				costPayment.payments.push(newPayment);
			}
			const updatedCostsPayments = this.costsPayments?.map(cp =>
				cp.id === costPayment.id ? costPayment : cp
			);
			this.$emit('update:costsPayments', updatedCostsPayments);
		},
		calcFontColor(backgroundColor){
			if (!backgroundColor) return '#000';
			let hex = backgroundColor.replace('#', '');
			if (hex.length === 3) {
				hex = hex.split('').map(char => char + char).join('');
			}
			const r = parseInt(hex.substring(0, 2), 16);
			const g = parseInt(hex.substring(2, 4), 16);
			const b = parseInt(hex.substring(4, 6), 16);
			const brightness = (r * 299 + g * 587 + b * 114) / 1000;
			return brightness > 128 ? '#000' : '#fff';
		},
    openColorPicker(key) {
      this.activeColorKey = key
      this.colorPickerVisible = true
    },
		editProjectPlanning(){
			this.$store.commit('projects/setProjectPlanningConfigModal', {project: this.project, status: true})
		},
		getParentItemValues(parentItem) {
			const value = getParentItemTotalValueWithTax(parentItem, this.costsTable.tax?.value)
			return value
		},
		debounceSetMessage: _debounce(function(messageData){ this.setMessage(messageData) }, 200),
    setMessage(messageData){
      const data = {
        message: messageData.message,
        title: messageData.title,
        created: new Date(),
        type: messageData.type,
        icon: messageData.icon,
        color: messageData.color,
      }
      this.$store.dispatch('general/addMessage', data)
    },
		removeItemFromSubcontract(item, itemType) {
			// Elimina el elemento de la asignación de subcontrato
			const projectTable = item.project_table;
			
			if (!projectTable) {
				this.setMessage({
					message: 'Error: No se encontró la tabla de costos.',
					type: 'error',
					icon: 'mdi-alert-circle-outline',
					color: 'red',
				});
				return;
			}

			let removed = false;

			if (itemType === 'cost_table') {
				if (projectTable.subcontract) {
					projectTable.subcontracts_info = {
						...projectTable.subcontracts_info,
						cost_table: {
							...projectTable.subcontracts_info?.cost_table,
							subcontract: null,
							contractor: null,
							contractor_id: null,
						}
					};
					removed = true;
				}
			} else if (itemType === 'stage') {
				// Eliminar de stages - actualizar elemento específico en el array
				if (projectTable.subcontracts_info?.stages && Array.isArray(projectTable.subcontracts_info.stages)) {
					const index = projectTable.subcontracts_info.stages.findIndex(s => s.id === item.id);
					if (index !== -1) {
						const updatedStages = [...projectTable.subcontracts_info.stages];
						updatedStages[index] = {
							...updatedStages[index],
							subcontract: null,
							contractor: null,
							contractor_id: null,
						};
						projectTable.subcontracts_info = {
							...projectTable.subcontracts_info,
							stages: updatedStages
						};
						removed = true;
					}
				}
			} else if (itemType === 'specialty') {
				if (projectTable.subcontracts_info?.specialties && Array.isArray(projectTable.subcontracts_info.specialties)) {
					const index = projectTable.subcontracts_info.specialties.findIndex(s => s.id === item.id);
					if (index !== -1) {
						const updatedSpecialties = [...projectTable.subcontracts_info.specialties];
						updatedSpecialties[index] = {
							...updatedSpecialties[index],
							subcontract: null,
							contractor: null,
							contractor_id: null,
						};
						projectTable.subcontracts_info = {
							...projectTable.subcontracts_info,
							specialties: updatedSpecialties
						};
						removed = true;
					}
				}
			} else if (itemType === 'reception') {
				// Limpiar reception
				if (projectTable.subcontracts_info?.reception?.id === item.id) {
					projectTable.subcontracts_info = {
						...projectTable.subcontracts_info,
						reception: {
							...projectTable.subcontracts_info?.reception,
							subcontract: null,
							contractor: null,
							contractor_id: null,
						}
					};
					removed = true;
				}
			}

			// Actualizar las propiedades reactivas (costTableSubcontractinfo, etc) llamando a setBaseValues
			this.setBaseValues();

			// Mostrar mensaje de confirmación
			this.setMessage({
				message: removed ? 'Elemento eliminado del subcontrato.' : 'No se pudo eliminar el elemento.',
				title: removed ? 'Eliminado' : 'Advertencia',
				type: removed ? 'success' : 'warning',
				icon: removed ? 'mdi-check-circle-outline' : 'mdi-alert-circle-outline',
				color: removed ? 'green' : 'orange',
			});
		},
		handleUpdateSubpaymentAmount(payload) {
			const { amount, paymentIndex, costPaymentIndex, itemType, itemId, subcontractId } = payload;
			const costsPayment = this.costsPayments[costPaymentIndex]
			
			if (costsPayment) {
				const paymentType = this.mapItemTypeToPaymentType(itemType);
				this.updateSubpaymentValue(costsPayment, paymentIndex, amount, paymentType, itemId, subcontractId);
			}
		},
		handleUpdateSubpaymentTitle(payload) {
			const { title, paymentIndex, costPaymentIndex, itemType, itemId, subcontractId } = payload;
			const costsPayment = this.costsPayments[costPaymentIndex]
			
			if (costsPayment) {
				const paymentType = this.mapItemTypeToPaymentType(itemType);
				this.updateSubpaymentTitle(costsPayment, paymentIndex, title, paymentType, itemId, subcontractId);
			}
		},
		handleRemoveSubpayment(payload) {
			const { paymentIndex, costPaymentIndex, itemType, itemId, subcontractId } = payload;
			const costsPayment = this.costsPayments[costPaymentIndex]
			
			if (costsPayment) {
				const paymentType = this.mapItemTypeToPaymentType(itemType);
				this.removeSubpayment(costsPayment, paymentIndex, paymentType, itemId, subcontractId);
			}
		},
		mapItemTypeToPaymentType(itemType) {
			const typeMap = {
				'mainProject': 'cost_table',
				'stage': 'stage',
				'specialty': 'specialty',
				'reception': 'reception'
			};
			return typeMap[itemType] || itemType;
		},
		hasPaymentInStage(subcontract, costsPayment) {
			// Verificar si hay al menos un payment configurado para esta etapa en algún item del subcontrato
			if (!subcontract || !costsPayment) return false;
			// Revisar mainProjects
			if (subcontract.items?.mainProjects && Array.isArray(subcontract.items.mainProjects)) {
				for (const item of subcontract.items.mainProjects) {
					const payment = this.getPaymentValue(costsPayment, 'cost_table', item.project_table?.id, subcontract.subcontract?.id);
					if (payment && payment.amount > 0) return true;
				}
			}

			// Revisar stages
			if (subcontract.items?.stages && Array.isArray(subcontract.items.stages)) {
				for (const item of subcontract.items.stages) {
					const payment = this.getPaymentValue(costsPayment, 'stage', item.item_id, subcontract.subcontract?.id);
					if (payment && payment.amount > 0) return true;
				}
			}

			// Revisar specialties
			if (subcontract.items?.specialties && Array.isArray(subcontract.items.specialties)) {
				for (const item of subcontract.items.specialties) {
					const payment = this.getPaymentValue(costsPayment, 'specialty', item.item_id, subcontract.subcontract?.id);
					if (payment && payment.amount > 0) return true;
				}
			}

			// Revisar reception
			if (subcontract.items?.reception) {
				const payment = this.getPaymentValue(costsPayment, 'reception', subcontract.items.reception.id, subcontract.subcontract?.id);
				if (payment && payment.amount > 0) return true;
			}

			return false;
		},
		getCorrelativeStageIndex(subcontract, indexPayment) {
			let correlativeIndex = 0;
			for (let i = 0; i < this.costsPayments.length; i++) {
				if (this.hasPaymentInStage(subcontract, this.costsPayments[i])) {
					if (i === indexPayment) {
						return correlativeIndex + 1;
					}
					correlativeIndex++;
				}
			}
			return -1;
		},
		startSaveEvent: _debounce(function() { this.saveCostsTable() }, 800),
		async saveCostsTable(){
			const data = {
				...this.costsTable,
				project_cost_id: this.costsTable.id,
				parent_project_cost_id: this.costsTable.id
			}
			
			const save_costs = await saveProjectCostDetail(data)
			if(save_costs.code == 200){
				const messageData = {
					message: 'Tabla de Costo guardada correctamente',
					title: 'Tabla de Costo Guardada',
					type: 'success',
					icon: 'mdi-check-circle',
					color: '#3EBFA3',
				}
				this.debounceSetMessage(messageData)
			}
			else{
				const messageData = {
					message: 'Hubo un error en la operación, por favor intenta nuevamente',
					title: 'Ha ocurrido un error',
					type: 'danger',
					icon: 'mdi-close-octagon',
					color: '#FF1209',
				}
				this.setMessage(messageData)
			}
		},
		getSubcontractItemsWithType(subcontract) {
			if (!subcontract || !subcontract.items) return [];

			const items = [];
			(subcontract.items.mainProjects || []).forEach(item => {
				items.push({
					item,
					itemType: 'cost_table',
					itemTypeId: item?.project_table?.id
				});
			});
			(subcontract.items.stages || []).forEach(item => {
				items.push({
					item,
					itemType: 'stage',
					itemTypeId: item?.stage?.id || item?.item_id
				});
			});
			(subcontract.items.specialties || []).forEach(item => {
				items.push({
					item,
					itemType: 'specialty',
					itemTypeId: item?.specialty?.id || item?.item_id
				});
			});
			if (subcontract.items.reception) {
				items.push({
					item: subcontract.items.reception,
					itemType: 'reception',
					itemTypeId: subcontract.items.reception?.project_table?.reception?.id || subcontract.items.reception?.id || subcontract.items.reception?.item_id
				});
			}

			return items.filter(row => row.item && row.itemTypeId !== undefined && row.itemTypeId !== null);
		},
		calculateSubcontractTotals(subcontract) {
			const tax = this.getTaxValueFromSubcontract(subcontract);
			const rows = this.getSubcontractItemsWithType(subcontract);
			
			const totals = {
				cost_uf: 0,
				cost_clp: 0,
				tax_uf: 0,
				tax_clp: 0,
				total_with_tax_uf: 0,
				total_with_tax_clp: 0,
				tax
			};
			rows.forEach(({ item }) => {
				const costUf = parseFloat(item?.cost_value_uf) || 0;
				const costClp = parseFloat(item?.cost_value_clp) || 0;

				totals.cost_uf += costUf;
				totals.cost_clp += costClp;
				totals.tax_uf += this.getTaxFromValue(costUf, tax) || 0;
				totals.tax_clp += this.getTaxFromValue(costClp, tax) || 0;
				totals.total_with_tax_uf += this.getValueWithTax(costUf, tax) || 0;
				totals.total_with_tax_clp += this.getValueWithTax(costClp, tax) || 0;
			});

			return totals;
		},
		calculateSubcontractContractTotals(subcontract) {
			const totals = {
				uf: 0,
				clp: 0
			};

			if (!subcontract || !subcontract.items) return totals;

			const mainTax = this.summarySubcontractInfo?.tax || this.costsTable?.tax;

			(subcontract.items.mainProjects || []).forEach(item => {
				const value = this.getParentItemTotalValueMultiWithTax(
					[item?.project_table, item?.project_table?.surfaces],
					mainTax,
					this.ufValue
				);
				totals.uf += value?.total_cost_uf_taxed || 0;
				totals.clp += value?.total_cost_clp_taxed || 0;
			});

			(subcontract.items.stages || []).forEach(item => {
				const value = this.getParentItemTotalValueWithTax(
					item?.stage,
					item?.project_table?.tax,
					this.ufValue
				);
				totals.uf += value?.total_cost_uf_taxed || 0;
				totals.clp += value?.total_cost_clp_taxed || 0;
			});

			(subcontract.items.specialties || []).forEach(item => {
				const value = this.getParentItemTotalValueWithTax(
					item?.specialty,
					item?.project_table?.tax,
					this.ufValue
				);
				totals.uf += value?.total_cost_uf_taxed || 0;
				totals.clp += value?.total_cost_clp_taxed || 0;
			});

			if (subcontract.items.reception) {
				const value = this.getParentItemTotalValueWithTax(
					subcontract.items.reception?.project_table?.reception,
					mainTax,
					this.ufValue
				);
				totals.uf += value?.total_cost_uf_taxed || 0;
				totals.clp += value?.total_cost_clp_taxed || 0;
			}

			return totals;
		},
		getSubcontractPaymentTotals(subcontract, costsPayment) {
			const totals = {
				percent: 0,
				uf: 0,
				clp: 0
			};

			const subcontractId = subcontract?.subcontract?.id;
			if (!subcontractId || !costsPayment) return totals;

			const tax = this.getTaxValueFromSubcontract(subcontract);
			const rows = this.getSubcontractItemsWithType(subcontract);

			rows.forEach(({ item, itemType, itemTypeId }) => {
				const payment = this.getPaymentValue(costsPayment, itemType, itemTypeId, subcontractId);
				if (!payment) return;

				const paymentPercent = parseFloat(payment.amount) || 0;
				const costUf = parseFloat(item?.cost_value_uf) || 0;
				const costClp = parseFloat(item?.cost_value_clp) || 0;

				totals.percent += paymentPercent;
				totals.uf += (this.getValueWithTax(costUf, tax) || 0) * paymentPercent / 100;
				totals.clp += (this.getValueWithTax(costClp, tax) || 0) * paymentPercent / 100;
			});

			return totals;
		},
		getSubcontractConfiguredTotals(subcontract) {
			const totals = {
				percent: 0,
				uf: 0,
				clp: 0
			};

			const subcontractId = subcontract?.subcontract?.id;
			if (!subcontractId) return totals;

			const tax = this.getTaxValueFromSubcontract(subcontract);
			const rows = this.getSubcontractItemsWithType(subcontract);

			rows.forEach(({ item, itemType, itemTypeId }) => {
				const itemPercent = this.getAllPaymentPercentValues(itemType, itemTypeId, subcontractId) || 0;
				const costUf = parseFloat(item?.cost_value_uf) || 0;
				const costClp = parseFloat(item?.cost_value_clp) || 0;

				totals.uf += (this.getValueWithTax(costUf, tax) || 0) * itemPercent / 100;
				totals.clp += (this.getValueWithTax(costClp, tax) || 0) * itemPercent / 100;
			});

			const subcontractTotals = this.calculateSubcontractTotals(subcontract);
			const base = subcontractTotals.total_with_tax_uf || 0;
			totals.percent = base > 0 ? (totals.uf / base) * 100 : 0;

			return totals;
		}
  },
};
</script>

<style scoped>
	.costbreakdown-detail-table{
		table-layout: fixed;
		width: 100%;
	}
	tr.no-hover-cells,
	tr.no-hover-cells td {
		background-color: inherit !important;
	}
	.action-container{
		width: 60px;
		display: flex;
		align-items: center;
		justify-content: flex-end;
	}
	.custom-table-cost table .main-row{
		border-top: 2px solid #bcbcbc;
		border-bottom: 2px solid #bcbcbc;
	}
	.custom-table-cost table .header-rows-custom{
		/* background: rgb(120, 120, 120); */
		color: white;
		font-size: 10px;
		font-weight: bold;
	}
	.custom-table-cost table tbody tr.header-rows-custom td,
	.custom-table-cost table thead tr.header-rows-custom td{
		height: 25px;
	}
	.custom-table-cost table .header-rows-custom:hover{
		/* background: rgb(103, 103, 103) !important; */
	}
	.custom-table-cost table .header-rows-custom.indigo:hover{
		background: #3f51b5 !important;
	}
	.custom-table-cost table .header-rows-custom.green:hover{
		background: #4CAF50 !important;
	}
	.custom-table-cost table .header-rows-custom.warning:hover{
		background: #fb8c00 !important;
	}
	/deep/.costbreakdown-detail-table,
	/deep/.costbreakdown-detail-table td{
		vertical-align: top;
	}
	/deep/.costbreakdown-detail-table:hover {
		background-color: rgb(235, 235, 235);
	}

	/* Estilos para líneas jerárquicas */
	.hierarchy-container {
		position: relative;
		padding-left: 20px;
	}

	.hierarchy-line {
		position: absolute;
		left: 0;
		top: 0;
		bottom: 0;
		width: 16px;
		border-left: 2px solid #c0c0c0;
		border-bottom: 2px solid #c0c0c0;
		border-bottom-left-radius: 6px;
	}

	.hierarchy-line::before {
		content: '';
		position: absolute;
		width: 8px;
		height: 2px;
		background-color: #c0c0c0;
		top: 0;
		left: 8px;
	}

	.item-child {
		position: relative;
		padding-left: 8px;
	}

	.item-child::before {
		content: '';
		position: absolute;
		left: -8px;
		top: 0;
		bottom: 0;
		width: 1px;
		background-color: transparent;
	}
	.parent-node-line{
		border: 1px solid #999;
		padding: 5px;
		border-radius: 10px;
		max-width: 150px;
	}
	.child-node-line{
		margin-left: 30px;
	}
	.element-node-line{
		padding-left: 5px;
		/* border: 1px solid #999;
		padding: 5px;
		border-radius: 10px; */
	}
	/* /deep/.custom-table-cost table {
    -moz-border-radius: 10px;
    -webkit-border-radius: 10px;
    border-radius: 10px;
		overflow: hidden;
		border-spacing: 0;
	} */
</style>
<style>
	.custom-table-cost table {
		border-collapse: collapse;
	}
	.custom-table-cost table td{
		border: 1px solid #ccc;
	}
	.custom-type-number .v-input__slot{
		padding:0 4px!important;
	}
	input[type="number"]::-webkit-inner-spin-button,
	input[type="number"]::-webkit-outer-spin-button {
		-webkit-appearance: none;
		margin: 0;
	}
	input[type="number"] {
		-moz-appearance: textfield;
	}
	.single-blocked-content-cost-table button:not(.exclude-from-block),
	.single-blocked-content-cost-table input:not(.exclude-from-block),
	.single-blocked-content-cost-table .v-input:not(.exclude-from-block),
	.single-blocked-content-cost-table .v-button:not(.exclude-from-block) {
			pointer-events: none;
			opacity: 0.6;
	}

	/* INPUT */
	.custom-text-field .v-input__control input {
		color: var(--c) !important;
	}

	/* LABEL */
	.custom-text-field .v-label {
		color: var(--c) !important;
	}

	/* BORDE */
	.custom-text-field.v-text-field--outlined .v-field__outline,
	.custom-text-field.v-text-field--outlined fieldset {
		border-color: var(--c) !important;
	}

	/* HOVER */
	.custom-text-field:hover fieldset {
		border-color: var(--c) !important;
	}

	/* FOCUS */
	.custom-text-field.v-input--is-focused fieldset {
		border-color: var(--c) !important;
		border-width: 2px;
	}
</style>